webpackJsonp([9],{

/***/ 1314:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);

exports.__esModule = true;
exports.default = void 0;

var _extends3 = _interopRequireDefault(__webpack_require__(34));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(881));

var _react = __webpack_require__(0);

var _setDisplayName = _interopRequireDefault(__webpack_require__(409));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(478));

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var WithState =
    /*#__PURE__*/
    function (_Component) {
      (0, _inheritsLoose2.default)(WithState, _Component);

      function WithState() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
        _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        };

        _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        };

        return _this;
      }

      var _proto = WithState.prototype;

      _proto.render = function render() {
        var _extends2;

        return factory((0, _extends3.default)({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
      };

      return WithState;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName.default)((0, _wrapDisplayName.default)(BaseComponent, 'withState'))(WithState);
    }

    return WithState;
  };
};

var _default = withState;
exports.default = _default;

/***/ }),

/***/ 2043:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.defaultPageProps = void 0;
var _get2 = _interopRequireDefault(__webpack_require__(5));
var _cookieUtils = __webpack_require__(82);
var _queryString = _interopRequireDefault(__webpack_require__(65));
var defaultPageProps = exports.defaultPageProps =  true ? {
  userId: '[[user.userInfo.response.userId]]',
  kwcid: (0, _get2["default"])(_queryString["default"].parse(window.location.search), 's_kwcid') || (0, _cookieUtils.getCookie)('s_kwcid'),
  cid: (0, _get2["default"])(_queryString["default"].parse(window.location.search), 'cid')
} : {};
var defaultProps = exports.defaultProps = {
  userId: '[[user.userInfo.response.userId]]',
  userPrimaryZipCode: '[[user.primaryAddress.postalCode]]',
  userPrimaryAdZone: '[[user.primaryAddress.advertisingZone]]',
  userSelectedZipCode: '[[user.currentAddress.postalCode]]',
  userSelectedAdZone: '[[user.currentAddress.advertisingZone]]',
  pathName: '[[routing.locationBeforeTransitions.pathname]]'
};

/***/ }),

/***/ 2088:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markRequiredText = void 0;
var _react = _interopRequireDefault(__webpack_require__(0));
var markRequiredText = exports.markRequiredText = function markRequiredText(text) {
  return /*#__PURE__*/_react["default"].createElement("span", null, text, " ", /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-danger"
  }, "*"));
};

/***/ }),

/***/ 2090:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatAddress = void 0;
var _isEmpty2 = _interopRequireDefault(__webpack_require__(59));
var formatAddress = exports.formatAddress = function formatAddress(_ref) {
  var firstLine = _ref.firstLine,
    secondLine = _ref.secondLine,
    city = _ref.city,
    region = _ref.region,
    postalCode = _ref.postalCode;
  var formattedSecondLine = (0, _isEmpty2["default"])(secondLine) ? '' : " ".concat(secondLine);
  return "".concat(firstLine).concat(formattedSecondLine, " ").concat(city, ", ").concat(region, " ").concat(postalCode);
};

/***/ }),

/***/ 2099:
/***/ (function(module, exports) {

/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */
function fromPairs(pairs) {
  var index = -1,
      length = pairs == null ? 0 : pairs.length,
      result = {};

  while (++index < length) {
    var pair = pairs[index];
    result[pair[0]] = pair[1];
  }
  return result;
}

module.exports = fromPairs;


/***/ }),

/***/ 2100:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(2));
var _angieslistAppPlatform = __webpack_require__(1);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports["default"] = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _angieslistAppPlatform.AsyncRequest.createActionKeys('SAVE_ASSOCIATE_CONTACT_PREFERENCES')), _angieslistAppPlatform.AsyncRequest.createActionKeys('GET_ASSOCIATE_CONTACT_PREFERENCES')), _angieslistAppPlatform.AsyncRequest.createActionKeys('UPDATE_ASSOCIATE_CONTACT_PREF_STATE')), _angieslistAppPlatform.AsyncRequest.createActionKeys('GET_ASSOCIATE_CONTACT_PREFERENCES_BY_EMAIL')), _angieslistAppPlatform.AsyncRequest.createActionKeys('SAVE_ASSOCIATE_CONTACT_PREFERENCES_BY_EMAIL')), _angieslistAppPlatform.AsyncRequest.createActionKeys('UNSUBSCRIBE_FROM_ASSOCIATE_CONTACT_PREFERENCE_BY_EMAIL'));
module.exports = exports.default;

/***/ }),

/***/ 2101:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(0));
var _propTypes = _interopRequireDefault(__webpack_require__(4));
var _compose = _interopRequireDefault(__webpack_require__(7));
var _pure = _interopRequireDefault(__webpack_require__(6));
var ContactPreferenceCopy = function ContactPreferenceCopy(_ref) {
  var email = _ref.email;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "You are currently scheduled to receive the following \"checked\" correspondence.  To change your preferences, simply \"check\" or \"uncheck\" the related box.  Click \"Save\" to save your changes.\xA0\xA0", /*#__PURE__*/_react["default"].createElement("em", null, "While changes are usually immediate, please allow five (5) business days to ensure they have taken effect.")), /*#__PURE__*/_react["default"].createElement("p", null, "By the way, your emails are currently being sent to \xA0", /*#__PURE__*/_react["default"].createElement("strong", null, email), "."));
};
ContactPreferenceCopy.propTypes = {
  email: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = (0, _compose["default"])(_pure["default"])(ContactPreferenceCopy);
module.exports = exports.default;

/***/ }),

/***/ 2102:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixContactPrefLinks = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(2));
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
var _split6 = _interopRequireDefault(__webpack_require__(980));
var _react = _interopRequireDefault(__webpack_require__(0));
var _angieslistAppPlatform = __webpack_require__(1);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var a = function a(text, url) {
  return /*#__PURE__*/_react["default"].createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: url
  }, text);
};
var userAgreement = a('Service Provider\'s User Agreement', _angieslistAppPlatform.urlCatalog.global.serviceProviderUserAgreement());
var privacyPolicy = a('Privacy Policy', _angieslistAppPlatform.urlCatalog.global.privacyPolicy());
var fixContactPrefLinks = exports.fixContactPrefLinks = function fixContactPrefLinks(pref, appName) {
  if (pref.key === 'message_center_sms' || pref.key === 'telephone' && appName === 'office-app') {
    var _split2 = (0, _split6["default"])(pref.description, 'Service Provider\'s User Agreement'),
      _split3 = (0, _slicedToArray2["default"])(_split2, 2),
      beginning = _split3[0],
      rest = _split3[1];
    var _split4 = (0, _split6["default"])(rest, 'Privacy Policy'),
      _split5 = (0, _slicedToArray2["default"])(_split4, 2),
      middle = _split5[0],
      end = _split5[1];
    var newDesc = /*#__PURE__*/_react["default"].createElement("p", null, beginning, userAgreement, middle, privacyPolicy, end);
    return _objectSpread({}, _objectSpread(_objectSpread({}, pref), {}, {
      description: newDesc
    }));
  } else {
    return pref;
  }
};

/***/ }),

/***/ 2105:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.encodedQueryParam = encodedQueryParam;
exports.parseNumberFromQueryParam = parseNumberFromQueryParam;
exports.parseQueryParam = parseQueryParam;
var _isNaN2 = _interopRequireDefault(__webpack_require__(4302));
var _isArray2 = _interopRequireDefault(__webpack_require__(103));
var _isElement2 = _interopRequireDefault(__webpack_require__(4303));
var _first2 = _interopRequireDefault(__webpack_require__(2106));
var _get2 = _interopRequireDefault(__webpack_require__(5));
var _queryString = _interopRequireDefault(__webpack_require__(65));
function parseQueryParam(searchQuery, paramName) {
  var queryParams = _queryString["default"].parse(searchQuery);
  var param = (0, _get2["default"])(queryParams, paramName, '');
  // multiple params may get passed through with the same param name - use first param
  return (0, _isElement2["default"])(param) || (0, _isArray2["default"])(param) ? (0, _first2["default"])(param) : param;
}
function encodedQueryParam(searchQuery, paramName) {
  var queryParams = _queryString["default"].parse(searchQuery);
  var param = (0, _get2["default"])(queryParams, paramName, '');
  var encodedParam = encodeURIComponent(param);
  return encodedParam;
}
function parseNumberFromQueryParam(searchQuery, paramName) {
  var parsedValue = parseInt(parseQueryParam(searchQuery, paramName), 10);
  return (0, _isNaN2["default"])(parsedValue) ? undefined : parsedValue;
}

/***/ }),

/***/ 2107:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emailIsRequired = void 0;
exports.validateEmail = validateEmail;
var _isEmpty2 = _interopRequireDefault(__webpack_require__(59));
var _angieslistAppPlatform = __webpack_require__(1);
// Validation rules: https://angieslist.atlassian.net/wiki/display/SE/Data+Validation

var emailIsRequired = exports.emailIsRequired = {
  email: {
    required: true,
    pattern: 'email'
  }
};
function validateEmail(email) {
  return !(0, _isEmpty2["default"])(email) && _angieslistAppPlatform.validation.validate({
    email: email
  }, emailIsRequired).isValid;
}

/***/ }),

/***/ 2135:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16);
  rng = function whatwgRNG() {
    crypto.getRandomValues(rnds8);
    return rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var  rnds = new Array(16);
  rng = function() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

module.exports = rng;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),

/***/ 2136:
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return  bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;


/***/ }),

/***/ 2137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateAssociateContactPrefStateByEmail = updateAssociateContactPrefStateByEmail;
exports.updateUserContactPrefStateByEmail = updateUserContactPrefStateByEmail;
function updateUserContactPrefStateByEmail() {
  var cPreferences = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: 'UPDATE_USER_CONTACT_PREF_STATE_BY_EMAIL',
    payload: cPreferences
  };
}
function updateAssociateContactPrefStateByEmail() {
  var cPreferences = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: 'UPDATE_ASSOCIATE_CONTACT_PREF_STATE_BY_EMAIL',
    payload: cPreferences
  };
}

/***/ }),

/***/ 2818:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(136);
module.exports = __webpack_require__(2992);


/***/ }),

/***/ 2992:
/***/ (function(module, exports, __webpack_require__) {

/* generated file - do not modify */
var onWindowIntl = function onWindowIntl() {
  __webpack_require__(137)(__webpack_require__(3075), [__webpack_require__(142), __webpack_require__(4389)], 'en', {
    "authorized": false
  });

  var _require = __webpack_require__(98),
      addLocaleData = _require.addLocaleData;

  [__webpack_require__(143)].forEach(function (locale) {
    return addLocaleData(locale);
  });
};

var ensureFetch = function ensureFetch(cb) {
  if (typeof fetch === 'undefined') {
    __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function (require) {
      __webpack_require__(148);

      cb();
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  } else {
    cb();
  }
};

var ensureIntl = function ensureIntl(cb) {
  if (typeof window.Intl === 'undefined') {
    __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function (require) {
      __webpack_require__(56);

      __webpack_require__(57);

      cb();
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  } else {
    cb();
  }
}; // Check window.Intl, then check window.fetch, then load


ensureIntl(function () {
  ensureFetch(onWindowIntl);
});

/***/ }),

/***/ 3075:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_browser_App__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_account_ion_lib_modules_office_browser_routes_routes__ = __webpack_require__(4035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_account_ion_lib_modules_office_browser_routes_routes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_account_ion_lib_modules_office_browser_routes_routes__);
 // eslint-disable-next-line import/first


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_1_account_ion_lib_modules_office_browser_routes_routes___default()(__WEBPACK_IMPORTED_MODULE_0__app_browser_App__["a" /* default */]));

/***/ }),

/***/ 4035:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(0));
var _IndexRoute = _interopRequireDefault(__webpack_require__(167));
var _Route = _interopRequireDefault(__webpack_require__(151));
var _browser = __webpack_require__(118);
var _myAccount = _interopRequireDefault(__webpack_require__(4056));
var _contactPreferences = _interopRequireDefault(__webpack_require__(4299));
var _default = exports["default"] = function _default(App) {
  return function createRoutes(getState, dispatch) {
    return /*#__PURE__*/_react["default"].createElement(_Route["default"], {
      component: App,
      path: "/app/account"
    }, /*#__PURE__*/_react["default"].createElement(_IndexRoute["default"], {
      component: function component() {
        return /*#__PURE__*/_react["default"].createElement(_myAccount["default"], {
          showContactPrefModal: false
        });
      }
    }), /*#__PURE__*/_react["default"].createElement(_Route["default"], {
      path: "preferences"
    }, /*#__PURE__*/_react["default"].createElement(_IndexRoute["default"], {
      component: function component() {
        return /*#__PURE__*/_react["default"].createElement(_myAccount["default"], {
          showContactPrefModal: true
        });
      }
    }), /*#__PURE__*/_react["default"].createElement(_Route["default"], {
      component: function component() {
        return /*#__PURE__*/_react["default"].createElement(_contactPreferences["default"], null);
      },
      path: "unsubscribe"
    })), /*#__PURE__*/_react["default"].createElement(_Route["default"], {
      component: _browser.OfficeNotFoundView,
      path: "*"
    }));
  };
};
module.exports = exports.default;

/***/ }),

/***/ 4056:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
var _typeof = __webpack_require__(46);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(2));
var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));
var _createClass2 = _interopRequireDefault(__webpack_require__(11));
var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(12));
var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
var _inherits2 = _interopRequireDefault(__webpack_require__(14));
var _get2 = _interopRequireDefault(__webpack_require__(5));
__webpack_require__(4057);
var _icons = __webpack_require__(150);
var _withRouter = _interopRequireDefault(__webpack_require__(496));
var _react = _interopRequireDefault(__webpack_require__(0));
var _reactHelmetAsync = _interopRequireDefault(__webpack_require__(58));
var _propTypes = _interopRequireDefault(__webpack_require__(4));
var _reactRedux = __webpack_require__(16);
var _compose = _interopRequireDefault(__webpack_require__(7));
var _pure = _interopRequireDefault(__webpack_require__(6));
var _myAccount2 = _interopRequireDefault(__webpack_require__(4058));
var _angieslistAppPlatform = __webpack_require__(1);
var _Grid = _interopRequireDefault(__webpack_require__(41));
var _Row = _interopRequireDefault(__webpack_require__(9));
var _Col = _interopRequireDefault(__webpack_require__(15));
var _Button = _interopRequireDefault(__webpack_require__(17));
var _personalDetails = _interopRequireDefault(__webpack_require__(4059));
var _addressInformation = _interopRequireDefault(__webpack_require__(4254));
var _contactPreferences = _interopRequireDefault(__webpack_require__(4291));
var memberMgmtActions = _interopRequireWildcard(__webpack_require__(578));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var editButtonStyle = 'primary-office';
var cancelButtonStyle = 'default-office';
var SP_TYPE_ADS = 'Ads';
var SP_TYPE_LEADS = 'Leads';
var SP_TYPE_DUAL = 'Dual';
var SP_TYPE_NONE = 'None';
var determineSpType = function determineSpType(entitlements) {
  var serviceProvider = entitlements.filter(function (ent) {
    return ent.scope === 'ServiceProvider';
  });
  var hasLeads = serviceProvider.filter(function (ent) {
    return ent.permission === 'AngiLeadsAdmin';
  }).length;
  var hasAds = serviceProvider.filter(function (ent) {
    return ent.permission !== 'AngiLeadsAdmin';
  }).length;
  if (hasAds && hasLeads) {
    return SP_TYPE_DUAL;
  } else if (hasAds && !hasLeads) {
    return SP_TYPE_ADS;
  } else if (!hasAds && hasLeads) {
    return SP_TYPE_LEADS;
  } else {
    return SP_TYPE_NONE;
  }
};

// This must be a 'class' and not a pure render method so that HMR will work
/* eslint react/prefer-stateless-function: 0 */
var MyAccountContainer = /*#__PURE__*/function (_React$Component) {
  function MyAccountContainer() {
    (0, _classCallCheck2["default"])(this, MyAccountContainer);
    return _callSuper(this, MyAccountContainer, arguments);
  }
  (0, _inherits2["default"])(MyAccountContainer, _React$Component);
  return (0, _createClass2["default"])(MyAccountContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$memberMan = _this$props.memberManagementGateway,
        fetchUser = _this$props$memberMan.fetchUser,
        deleteUserAddress = _this$props$memberMan.deleteUserAddress,
        setPrimaryAddress = _this$props$memberMan.setPrimaryAddress,
        changePassword = _this$props$memberMan.changePassword,
        deleteUserAddressApi = _this$props.deleteUserAddress,
        setPrimaryAddressApi = _this$props.setPrimaryAddress,
        changeUserPasswordApi = _this$props.changeUserPassword,
        resetChangeUserPassword = _this$props.resetChangeUserPassword,
        showContactPrefModal = _this$props.showContactPrefModal,
        userInfo = _this$props.user.userInfo,
        router = _this$props.router;
      var email = (0, _get2["default"])(userInfo, 'response.email');
      var userId = (0, _get2["default"])(userInfo, 'response.userId');
      var spType = determineSpType((0, _get2["default"])(userInfo, 'response.entitlements', []));
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactHelmetAsync["default"], null, /*#__PURE__*/_react["default"].createElement("title", null, "Business Center - Account")), /*#__PURE__*/_react["default"].createElement(_Grid["default"], null, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        bsStyle: "link",
        id: "edit-credit-card-back-button",
        bsSize: "small",
        onClick: router.goBack
      }, /*#__PURE__*/_react["default"].createElement(_icons.ArrowLeftIcon, {
        id: "edit-credit-card-back-arrow",
        height: 10
      }), /*#__PURE__*/_react["default"].createElement("span", null, " Back")), /*#__PURE__*/_react["default"].createElement("h2", {
        id: "my-account-personal-settings-header"
      }, "Personal account settings"), /*#__PURE__*/_react["default"].createElement("p", null, "These settings are for your individual Angi account. They won't impact your business settings or any affiliated team members' account. "), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_personalDetails["default"], {
        editButtonStyle: editButtonStyle,
        fetchUser: fetchUser,
        changePassword: changePassword,
        changeUserPasswordApi: changeUserPasswordApi,
        resetChangeUserPassword: resetChangeUserPassword
      }), /*#__PURE__*/_react["default"].createElement(_addressInformation["default"], {
        editButtonStyle: editButtonStyle,
        fetchUser: fetchUser,
        deleteUserAddress: deleteUserAddress,
        setPrimaryAddress: setPrimaryAddress,
        deleteUserAddressApi: deleteUserAddressApi,
        setPrimaryAddressApi: setPrimaryAddressApi
      }), spType === SP_TYPE_ADS || spType === SP_TYPE_DUAL ? /*#__PURE__*/_react["default"].createElement(_contactPreferences["default"], {
        editButtonStyle: editButtonStyle,
        cancelButtonStyle: cancelButtonStyle,
        userId: userId,
        email: email,
        showContactPrefModal: showContactPrefModal
      }) : null))));
    }
  }]);
}(_react["default"].Component);
MyAccountContainer.propTypes = {
  memberManagementGateway: _propTypes["default"].shape({
    fetchUser: _propTypes["default"].object.isRequired,
    deleteUserAddress: _propTypes["default"].object.isRequired,
    setPrimaryAddress: _propTypes["default"].object.isRequired,
    changePassword: _propTypes["default"].object.isRequired
  }).isRequired,
  user: _propTypes["default"].shape({
    userInfo: _propTypes["default"].object.isRequired
  }).isRequired,
  deleteUserAddress: _propTypes["default"].func.isRequired,
  setPrimaryAddress: _propTypes["default"].func.isRequired,
  changeUserPassword: _propTypes["default"].func.isRequired,
  resetChangeUserPassword: _propTypes["default"].func.isRequired,
  showContactPrefModal: _propTypes["default"].bool.isRequired,
  router: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = (0, _compose["default"])((0, _angieslistAppPlatform.withAuthentication)({}), (0, _angieslistAppPlatform.analytics)({
  ruleset: _myAccount2["default"]
}), _withRouter["default"], (0, _reactRedux.connect)(function (state) {
  return {
    memberManagementGateway: state.memberManagementGateway,
    user: state.user
  };
}, _objectSpread({}, memberMgmtActions)), _pure["default"])(MyAccountContainer);
module.exports = exports.default;

/***/ }),

/***/ 4057:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 4058:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(2));
var _defaultAnalyticsProps = __webpack_require__(2043);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports["default"] = {
  page: {
    name: 'SP : Account',
    properties: _objectSpread(_objectSpread({}, _defaultAnalyticsProps.defaultPageProps), {}, {
      name: 'SP : Account',
      title: 'Business Center - Account'
    })
  },
  elements: {
    'personal-details--edit-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Personal Details Section - Edit Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'personal-details--change-password-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Personal Details Section - Change Password Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'contact-preferences--edit-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Contact Preferences Section - Edit Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'address-information--add-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Address Information Section - Add Address Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'address-information--delete-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Address Information Section - Delete Address Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'address-information--primary-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Address Information Section - Make Primary Address Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'change-password-modal--change-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Change Password Modal - Change Password Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'change-password-modal--cancel-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Change Password Modal - Cancel Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'personal-details-modal--save-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Personal Details Modal - Save Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'personal-details-modal--close-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Personal Details Modal - Close Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'add-address-modal--save-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Add Address Modal - Save Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'add-address-modal--close-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Add Address Modal - Close Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'contact-preferences-modal--save-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Contact Preferences Modal - Save Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    },
    'contact-preferences-modal--cancel-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread({
          activityLocation: 'SP : Account',
          description: 'Contact Preferences Modal - Cancel Button'
        }, _defaultAnalyticsProps.defaultProps)
      }
    }
  }
};
module.exports = exports.default;

/***/ }),

/***/ 4059:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isEmpty2 = _interopRequireDefault(__webpack_require__(59));
var _get2 = _interopRequireDefault(__webpack_require__(5));
var _react = _interopRequireDefault(__webpack_require__(0));
var _propTypes = _interopRequireDefault(__webpack_require__(4));
var _compose = _interopRequireDefault(__webpack_require__(7));
var _pure = _interopRequireDefault(__webpack_require__(6));
var _withState = _interopRequireDefault(__webpack_require__(1314));
var _angieslistAppPlatform = __webpack_require__(1);
var _stringUtils = _interopRequireDefault(__webpack_require__(368));
var _getErrorMessage = _interopRequireDefault(__webpack_require__(264));
var _Alert = _interopRequireDefault(__webpack_require__(33));
var _Button = _interopRequireDefault(__webpack_require__(17));
var _ButtonToolbar = _interopRequireDefault(__webpack_require__(204));
var _Panel = _interopRequireDefault(__webpack_require__(177));
var _ButtonGroup = _interopRequireDefault(__webpack_require__(705));
var _changePasswordModal = _interopRequireDefault(__webpack_require__(4060));
var _personalDetailsModal = _interopRequireDefault(__webpack_require__(4251));
var PersonalDetails = function PersonalDetails(_ref) {
  var editButtonStyle = _ref.editButtonStyle,
    _ref$fetchUser = _ref.fetchUser,
    isUserLoading = _ref$fetchUser.isLoading,
    user = _ref$fetchUser.response,
    userError = _ref$fetchUser.error,
    changeUserPasswordApi = _ref.changeUserPasswordApi,
    resetChangeUserPassword = _ref.resetChangeUserPassword,
    changePassword = _ref.changePassword,
    showPasswordModal = _ref.showPasswordModal,
    setPasswordShowModal = _ref.setPasswordShowModal,
    showDetailsModal = _ref.showDetailsModal,
    setDetailsShowModal = _ref.setDetailsShowModal;
  var handlePasswordShow = function handlePasswordShow() {
    return setPasswordShowModal(true);
  };
  var handlePasswordClose = function handlePasswordClose() {
    return setPasswordShowModal(false);
  };
  var handleDetailsShow = function handleDetailsShow() {
    return setDetailsShowModal(true);
  };
  var handleDetailsClose = function handleDetailsClose() {
    return setDetailsShowModal(false);
  };
  var errorMessage = (0, _getErrorMessage["default"])(userError);
  return /*#__PURE__*/_react["default"].createElement(_Panel["default"], null, /*#__PURE__*/_react["default"].createElement(_Panel["default"].Heading, null, /*#__PURE__*/_react["default"].createElement(_Panel["default"].Title, null, "Personal Details")), /*#__PURE__*/_react["default"].createElement(_Panel["default"].Body, null, errorMessage ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    bsStyle: "danger"
  }, errorMessage) : null, !isUserLoading && !(0, _isEmpty2["default"])(user) ? [/*#__PURE__*/_react["default"].createElement("dl", {
    className: "dl-horizontal",
    key: "0"
  }, /*#__PURE__*/_react["default"].createElement("dt", null, "Email Address:"), /*#__PURE__*/_react["default"].createElement("dd", null, user.email), /*#__PURE__*/_react["default"].createElement("dt", null, "Name:"), /*#__PURE__*/_react["default"].createElement("dd", null, user.firstName, " ", user.lastName), /*#__PURE__*/_react["default"].createElement("dt", null, "Home Phone:"), /*#__PURE__*/_react["default"].createElement("dd", null, _stringUtils["default"].formatPhoneNumber((0, _get2["default"])(user, 'primaryContactInformation.primaryPhoneNumber'))), /*#__PURE__*/_react["default"].createElement("dt", null, "Mobile:"), /*#__PURE__*/_react["default"].createElement("dd", null, _stringUtils["default"].formatPhoneNumber((0, _get2["default"])(user, 'primaryContactInformation.mobilePhoneNumber')))), /*#__PURE__*/_react["default"].createElement(_ButtonToolbar["default"], {
    key: "1"
  }, /*#__PURE__*/_react["default"].createElement(_personalDetailsModal["default"], {
    user: user,
    editButtonStyle: editButtonStyle,
    showModal: showDetailsModal,
    handleClose: handleDetailsClose
  }), /*#__PURE__*/_react["default"].createElement(_ButtonGroup["default"], null, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "personal-details--edit-button",
    flat: true,
    bsStyle: editButtonStyle,
    bsSize: "small",
    style: {
      fontWeight: 'bold'
    },
    onClick: handleDetailsShow
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon icon-btn icon-pencil"
  }), " Edit"))), /*#__PURE__*/_react["default"].createElement(_changePasswordModal["default"], {
    changeUserPasswordApi: changeUserPasswordApi,
    editButtonStyle: editButtonStyle,
    changePassword: changePassword,
    resetChangeUserPassword: resetChangeUserPassword,
    showModal: showPasswordModal,
    handleClose: handlePasswordClose
  }), /*#__PURE__*/_react["default"].createElement(_ButtonGroup["default"], null, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "personal-details--change-password-button",
    flat: true,
    bsStyle: editButtonStyle,
    bsSize: "small",
    style: {
      fontWeight: 'bold'
    },
    onClick: handlePasswordShow
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon icon-btn icon-lock"
  }), " Change Password"))))] : null));
};
PersonalDetails.propTypes = {
  editButtonStyle: _propTypes["default"].string.isRequired,
  fetchUser: _propTypes["default"].shape({
    isLoading: _propTypes["default"].bool,
    response: _propTypes["default"].shape({
      email: _propTypes["default"].string,
      firstName: _propTypes["default"].string,
      lastName: _propTypes["default"].string,
      primaryContactInformation: _propTypes["default"].shape({
        primaryPhoneNumber: _propTypes["default"].string,
        mobilePhoneNumber: _propTypes["default"].string
      })
    }),
    error: _propTypes["default"].object
  }).isRequired,
  changeUserPasswordApi: _propTypes["default"].func.isRequired,
  resetChangeUserPassword: _propTypes["default"].func.isRequired,
  changePassword: _propTypes["default"].shape({
    isLoading: _propTypes["default"].bool,
    error: _propTypes["default"].object
  }),
  showPasswordModal: _propTypes["default"].bool.isRequired,
  setPasswordShowModal: _propTypes["default"].func.isRequired,
  showDetailsModal: _propTypes["default"].bool.isRequired,
  setDetailsShowModal: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _compose["default"])((0, _withState["default"])('showPasswordModal', 'setPasswordShowModal', false), (0, _withState["default"])('showDetailsModal', 'setDetailsShowModal', false), _pure["default"])(PersonalDetails);
module.exports = exports.default;

/***/ }),

/***/ 4060:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
__webpack_require__(4061);
var _react = _interopRequireDefault(__webpack_require__(0));
var _angieslistAppPlatform = __webpack_require__(1);
var _ReduxForm = _interopRequireDefault(__webpack_require__(245));
var _Row = _interopRequireDefault(__webpack_require__(9));
var _Col = _interopRequireDefault(__webpack_require__(15));
var _Button = _interopRequireDefault(__webpack_require__(17));
var _Alert = _interopRequireDefault(__webpack_require__(33));
var _Modal = _interopRequireDefault(__webpack_require__(55));
var _reduxForm = __webpack_require__(42);
var _propTypes = _interopRequireDefault(__webpack_require__(4));
var _compose = _interopRequireDefault(__webpack_require__(7));
var _pure = _interopRequireDefault(__webpack_require__(6));
var _changePassword = __webpack_require__(4250);
var _requiredTextLabel = __webpack_require__(2088);
var _getErrorMessage = _interopRequireDefault(__webpack_require__(264));
var changePasswordErrorMappings = {
  mappings: {
    '400': 'New password must not be the same as Old password',
    '403': 'Incorrect Old Password'
  }
};
var handleModalClose = function handleModalClose(handleClose, resetChangeUserPassword) {
  handleClose();
  resetChangeUserPassword();
};
var submit = function submit(changeUserPasswordApi, resetChangeUserPassword, handleClose, values) {
  changeUserPasswordApi(values.oldPassword, values.newPassword).then(function () {
    handleModalClose(handleClose, resetChangeUserPassword);
  });
};
var ChangePasswordModal = function ChangePasswordModal(_ref) {
  var changeUserPasswordApi = _ref.changeUserPasswordApi,
    editButtonStyle = _ref.editButtonStyle,
    handleSubmit = _ref.handleSubmit,
    changePassword = _ref.changePassword,
    pristine = _ref.pristine,
    invalid = _ref.invalid,
    resetChangeUserPassword = _ref.resetChangeUserPassword,
    handleClose = _ref.handleClose,
    showModal = _ref.showModal;
  var errorMessage = (0, _getErrorMessage["default"])(changePassword.error, changePasswordErrorMappings);
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    show: showModal,
    onHide: function onHide() {
      return handleModalClose(handleClose, resetChangeUserPassword);
    },
    backdrop: "static"
  }, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Header, {
    closeButton: true
  }, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Title, null, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "modal-title"
  }, "Change Password"))), /*#__PURE__*/_react["default"].createElement("form", {
    name: "reset-password",
    onSubmit: handleSubmit(function (values) {
      submit(changeUserPasswordApi, resetChangeUserPassword, handleClose, values);
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-body"
  }, errorMessage ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    bsStyle: "danger"
  }, errorMessage) : null, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_ReduxForm["default"].Input, {
    name: "oldPassword",
    id: "change-password-modal--old-password",
    type: "password",
    autoFocus: true,
    label: (0, _requiredTextLabel.markRequiredText)('Old Password:')
  }))), /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_ReduxForm["default"].Input, {
    name: "newPassword",
    id: "change-password-modal--new-password",
    type: "password",
    label: (0, _requiredTextLabel.markRequiredText)('New Password:')
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "list-parent"
  }, /*#__PURE__*/_react["default"].createElement("li", null, "Must be at least 8 characters."), /*#__PURE__*/_react["default"].createElement("li", null, "No more than 2 consecutive repeated characters"), /*#__PURE__*/_react["default"].createElement("li", {
    className: "list-item-last"
  }, "('oo' works, but not 'ooo')")))), /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_ReduxForm["default"].Input, {
    name: "newPasswordConfirmation",
    id: "change-password-modal--confirm-new-password",
    type: "password",
    label: (0, _requiredTextLabel.markRequiredText)('New Password (Confirm):')
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-footer"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "change-password-modal--change-button",
    flat: true,
    bsStyle: editButtonStyle,
    bsSize: "small",
    type: "submit",
    disabled: pristine || invalid || changePassword.isLoading,
    loading: changePassword.isLoading
  }, "Change")), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "change-password-modal--cancel-button",
    flat: true,
    bsStyle: "tertiary",
    bsSize: "small",
    onClick: function onClick() {
      return handleModalClose(handleClose, resetChangeUserPassword);
    }
  }, "Cancel")))));
};

// Prop Types
ChangePasswordModal.propTypes = {
  changeUserPasswordApi: _propTypes["default"].func,
  editButtonStyle: _propTypes["default"].string,
  changePassword: _propTypes["default"].shape({
    isLoading: _propTypes["default"].bool,
    error: _propTypes["default"].object
  }),
  resetChangeUserPassword: _propTypes["default"].func.isRequired,
  // Redux-form props
  handleSubmit: _propTypes["default"].func.isRequired,
  dirty: _propTypes["default"].bool.isRequired,
  pristine: _propTypes["default"].bool.isRequired,
  invalid: _propTypes["default"].bool.isRequired,
  handleClose: _propTypes["default"].func.isRequired,
  showModal: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = (0, _compose["default"])((0, _reduxForm.reduxForm)({
  form: 'reset-password',
  validate: function validate(values, _ref2) {
    var dirty = _ref2.dirty;
    return dirty ? _angieslistAppPlatform.validation.validate(values, _changePassword.changePasswordValidationRules).invalidAttrs : {};
  }
}), _pure["default"])(ChangePasswordModal);
module.exports = exports.default;

/***/ }),

/***/ 4061:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 4250:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changePasswordValidationRules = void 0;
// Validation rules: https://angieslist.atlassian.net/wiki/display/SE/Data+Validation

var changePasswordValidationRules = exports.changePasswordValidationRules = {
  oldPassword: {
    required: true
  },
  newPassword: {
    required: true,
    password: true,
    notEqualTo: 'oldPassword',
    msg: 'New password needs to meet the requirements'
  },
  newPasswordConfirmation: {
    required: true,
    equalTo: 'newPassword'
  }
};

/***/ }),

/***/ 4251:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
var _typeof = __webpack_require__(46);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(2));
var _get3 = _interopRequireDefault(__webpack_require__(5));
var _react = _interopRequireDefault(__webpack_require__(0));
var _reactRedux = __webpack_require__(16);
var _reduxForm = __webpack_require__(42);
var _compose = _interopRequireDefault(__webpack_require__(7));
var _pure = _interopRequireDefault(__webpack_require__(6));
var _ReduxForm = _interopRequireDefault(__webpack_require__(245));
var _ReduxFormPhoneNumber = _interopRequireDefault(__webpack_require__(498));
var _Button = _interopRequireDefault(__webpack_require__(17));
var _Row = _interopRequireDefault(__webpack_require__(9));
var _Col = _interopRequireDefault(__webpack_require__(15));
var _Input = _interopRequireDefault(__webpack_require__(66));
var _Alert = _interopRequireDefault(__webpack_require__(33));
var _Modal = _interopRequireDefault(__webpack_require__(55));
var _angieslistAppPlatform = __webpack_require__(1);
var _propTypes = _interopRequireDefault(__webpack_require__(4));
var memberMgmtActions = _interopRequireWildcard(__webpack_require__(578));
var myAccountUIActions = _interopRequireWildcard(__webpack_require__(579));
var _personalDetails = __webpack_require__(4253);
var _requiredTextLabel = __webpack_require__(2088);
var _getErrorMessage = _interopRequireDefault(__webpack_require__(264));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var submit = function submit(updateUser, values, userId, updatePersonalDetails, handleClose) {
  var personalDetails = {
    userId: Number(userId),
    firstName: values.firstName,
    lastName: values.lastName,
    contactInformation: {
      primaryPhoneNumber: values.primaryPhoneNumber,
      mobilePhoneNumber: values.mobilePhoneNumber
    }
  };
  updateUser(personalDetails).then(function () {
    updatePersonalDetails(personalDetails);
    handleClose();
  });
};
var PersonalDetailsModal = function PersonalDetailsModal(_ref) {
  var _ref$user = _ref.user,
    userId = _ref$user.userId,
    email = _ref$user.email,
    dirty = _ref.dirty,
    pristine = _ref.pristine,
    invalid = _ref.invalid,
    editButtonStyle = _ref.editButtonStyle,
    handleSubmit = _ref.handleSubmit,
    memberManagementGateway = _ref.memberManagementGateway,
    updateUser = _ref.updateUser,
    updatePersonalDetails = _ref.updatePersonalDetails,
    showModal = _ref.showModal,
    handleClose = _ref.handleClose;
  var _get2 = (0, _get3["default"])(memberManagementGateway, 'updateUser'),
    isUpdateUserLoading = _get2.isLoading,
    updateUserError = _get2.error;
  var errorMessage = (0, _getErrorMessage["default"])(updateUserError);
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    show: showModal,
    onHide: handleClose,
    backdrop: "static",
    id: "personal-details-modal"
  }, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Header, {
    closeButton: true
  }, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Title, null, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "modal-title"
  }, "Edit Personal Details"))), /*#__PURE__*/_react["default"].createElement("form", {
    name: "edit-personal-details",
    onSubmit: handleSubmit(function (values) {
      submit(updateUser, values, userId, updatePersonalDetails, handleClose);
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-body"
  }, errorMessage ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    bsStyle: "danger"
  }, errorMessage) : null, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    type: "static",
    value: email,
    label: "Email Address:"
  }), /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react["default"].createElement(_ReduxForm["default"].Input, {
    name: "firstName",
    type: "text",
    label: (0, _requiredTextLabel.markRequiredText)('First Name:'),
    id: "personal-details-modal--first-name"
  })), /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react["default"].createElement(_ReduxForm["default"].Input, {
    name: "lastName",
    type: "text",
    label: (0, _requiredTextLabel.markRequiredText)('Last Name:'),
    id: "personal-details-modal--last-name"
  }))), /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react["default"].createElement(_ReduxFormPhoneNumber["default"], {
    name: "primaryPhoneNumber",
    label: "Home Phone:",
    id: "personal-details-modal--home-phone"
  })), /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react["default"].createElement(_ReduxFormPhoneNumber["default"], {
    name: "mobilePhoneNumber",
    label: "Mobile Phone:",
    id: "personal-details-modal--mobile-phone"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-footer"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "personal-details-modal--save-button",
    flat: true,
    bsStyle: editButtonStyle,
    disabled: pristine || invalid || isUpdateUserLoading,
    loading: isUpdateUserLoading,
    bsSize: "small",
    type: "submit"
  }, "Save")), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "personal-details-modal--close-button",
    flat: true,
    bsSize: "small",
    bsStyle: "tertiary",
    onClick: handleClose
  }, "Cancel")))));
};

// Prop Types
PersonalDetailsModal.propTypes = {
  editButtonStyle: _propTypes["default"].string.isRequired,
  memberManagementGateway: _propTypes["default"].object,
  updateUser: _propTypes["default"].func.isRequired,
  updatePersonalDetails: _propTypes["default"].func.isRequired,
  // redux store
  user: _propTypes["default"].shape({
    userId: _propTypes["default"].number.isRequired,
    email: _propTypes["default"].string.isRequired,
    firstName: _propTypes["default"].string,
    lastName: _propTypes["default"].string,
    primaryContactInformation: _propTypes["default"].shape({
      primaryPhoneNumber: _propTypes["default"].string,
      mobilePhoneNumber: _propTypes["default"].string
    })
  }),
  // redux form
  dirty: _propTypes["default"].bool.isRequired,
  pristine: _propTypes["default"].bool.isRequired,
  invalid: _propTypes["default"].bool.isRequired,
  reset: _propTypes["default"].func.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired,
  handleClose: _propTypes["default"].func.isRequired,
  showModal: _propTypes["default"].bool.isRequired
};
var PersonalDetailsModalReduxForm = (0, _reduxForm.reduxForm)({
  form: 'edit-personal-details',
  validate: function validate(values) {
    return _angieslistAppPlatform.validation.validate(values, _personalDetails.personalDetailsValidationRules).invalidAttrs;
  }
})(PersonalDetailsModal);
var _default = exports["default"] = (0, _compose["default"])((0, _reactRedux.connect)(function (state, props) {
  return {
    memberManagementGateway: state.memberManagementGateway,
    initialValues: {
      firstName: props.user.firstName,
      lastName: props.user.lastName,
      primaryPhoneNumber: (0, _get3["default"])(props, 'user.primaryContactInformation.primaryPhoneNumber'),
      mobilePhoneNumber: (0, _get3["default"])(props, 'user.primaryContactInformation.mobilePhoneNumber')
    }
  };
}, _objectSpread(_objectSpread({}, memberMgmtActions), myAccountUIActions)), _pure["default"])(PersonalDetailsModalReduxForm);
module.exports = exports.default;

/***/ }),

/***/ 4252:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _angieslistAppPlatform = __webpack_require__(1);
var memberMgmtGatewayService = {
  fetchUser: function fetchUser(userId) {
    return _angieslistAppPlatform.httpClient.get("/gateway/member-management/v1/user/".concat(userId));
  },
  updateUser: function updateUser(data) {
    return _angieslistAppPlatform.httpClient.post('/gateway/member-management/v1/user/update', {
      body: data
    });
  },
  deleteUserAddress: function deleteUserAddress(userAddressId) {
    return _angieslistAppPlatform.httpClient.del("/gateway/member-management/v1/user/addresses/".concat(userAddressId));
  },
  setPrimaryAddress: function setPrimaryAddress(userAddressId) {
    return _angieslistAppPlatform.httpClient.put("/gateway/member-management/v1/user/addresses/primary/".concat(userAddressId));
  },
  changePassword: function changePassword(oldPassword, newPassword) {
    return _angieslistAppPlatform.httpClient.post('/gateway/member-management/v1/user/password/change', {
      body: {
        oldPassword: oldPassword,
        newPassword: newPassword
      }
    });
  },
  getUserContactPreferences: function getUserContactPreferences(userId) {
    return _angieslistAppPlatform.httpClient.get("/gateway/member-management/v1/member/".concat(userId, "/preferences"));
  },
  saveUserContactPreferences: function saveUserContactPreferences(data) {
    return _angieslistAppPlatform.httpClient.post('/gateway/member-management/v1/member/preferences', {
      body: data
    });
  },
  getMembershipInformation: function getMembershipInformation(userId) {
    return _angieslistAppPlatform.httpClient.get("/gateway/member-management/v1/member/".concat(userId, "/subscriptions"));
  },
  getEligibleForRefund: function getEligibleForRefund() {
    return _angieslistAppPlatform.httpClient.get('/gateway/member-management/v1/member/subscription/refundable');
  },
  cancelAutoRenew: function cancelAutoRenew() {
    return _angieslistAppPlatform.httpClient.post('/gateway/member-management/v1/member/subscriptions/donotrenew');
  },
  getUserContactPreferencesByEmail: function getUserContactPreferencesByEmail(email, apiToken) {
    return _angieslistAppPlatform.httpClient.get("/gateway/member-management/v1/member/preferences?email=".concat(email), {
      headers: {
        Authorization: apiToken
      }
    });
  },
  saveUserContactPreferencesByEmail: function saveUserContactPreferencesByEmail(_ref) {
    var email = _ref.email,
      apiToken = _ref.apiToken,
      preferences = _ref.preferences;
    return _angieslistAppPlatform.httpClient.post('/gateway/member-management/v1/member/preferences/unauth', {
      body: {
        email: email,
        preferences: preferences
      },
      headers: {
        Authorization: apiToken
      }
    });
  },
  submitPrivacyRequest: function submitPrivacyRequest(_ref2) {
    var email = _ref2.email,
      privacyRequestType = _ref2.privacyRequestType;
    return _angieslistAppPlatform.httpClient.post('/gateway/member-management/v1/user/privacy-request', {
      body: {
        email: email,
        privacyRequestType: privacyRequestType
      }
    });
  },
  verifyPrivacyRequest: function verifyPrivacyRequest(_ref3) {
    var email = _ref3.email,
      verificationToken = _ref3.verificationToken,
      requestStatus = _ref3.requestStatus;
    return _angieslistAppPlatform.httpClient.post('/gateway/member-management/v1/user/privacy-request/verify', {
      body: {
        email: email,
        verificationToken: verificationToken,
        requestStatus: requestStatus
      }
    });
  }
};
var _default = exports["default"] = memberMgmtGatewayService;
module.exports = exports.default;

/***/ }),

/***/ 4253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personalDetailsValidationRules = void 0;
// Validation rules: https://angieslist.atlassian.net/wiki/display/SE/Data+Validation

var personalDetailsValidationRules = exports.personalDetailsValidationRules = {
  firstName: {
    required: true,
    maxLength: 128,
    title: true
  },
  lastName: {
    required: true,
    maxLength: 128,
    title: true
  },
  'primaryPhoneNumber': {
    required: false,
    phoneNumber: true
  },
  'mobilePhoneNumber': {
    required: false,
    phoneNumber: true
  }
};

/***/ }),

/***/ 4254:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(34));
var _map2 = _interopRequireDefault(__webpack_require__(77));
var _filter2 = _interopRequireDefault(__webpack_require__(265));
var _find2 = _interopRequireDefault(__webpack_require__(79));
var _isEmpty2 = _interopRequireDefault(__webpack_require__(59));
var _get2 = _interopRequireDefault(__webpack_require__(5));
__webpack_require__(4255);
var _react = _interopRequireDefault(__webpack_require__(0));
var _formatAddress = __webpack_require__(2090);
var _propTypes = _interopRequireDefault(__webpack_require__(4));
var _compose = _interopRequireDefault(__webpack_require__(7));
var _pure = _interopRequireDefault(__webpack_require__(6));
var _withState = _interopRequireDefault(__webpack_require__(1314));
var _angieslistAppPlatform = __webpack_require__(1);
var _getErrorMessage = _interopRequireDefault(__webpack_require__(264));
var _Alert = _interopRequireDefault(__webpack_require__(33));
var _Button = _interopRequireDefault(__webpack_require__(17));
var _ButtonToolbar = _interopRequireDefault(__webpack_require__(204));
var _ListGroup = _interopRequireDefault(__webpack_require__(580));
var _ListGroupItem = _interopRequireDefault(__webpack_require__(581));
var _Panel = _interopRequireDefault(__webpack_require__(177));
var _ButtonGroup = _interopRequireDefault(__webpack_require__(705));
var _addAddressModal = _interopRequireDefault(__webpack_require__(4256));
var AddressInformation = function AddressInformation(_ref) {
  var editButtonStyle = _ref.editButtonStyle,
    _ref$fetchUser = _ref.fetchUser,
    isUserLoading = _ref$fetchUser.isLoading,
    user = _ref$fetchUser.response,
    userError = _ref$fetchUser.error,
    _ref$deleteUserAddres = _ref.deleteUserAddress,
    isDeleteAddressLoading = _ref$deleteUserAddres.isLoading,
    deleteAddressRequest = _ref$deleteUserAddres.request,
    deleteAddressError = _ref$deleteUserAddres.error,
    _ref$setPrimaryAddres = _ref.setPrimaryAddress,
    isSetPrimaryLoading = _ref$setPrimaryAddres.isLoading,
    setPrimaryAddressRequest = _ref$setPrimaryAddres.request,
    setPrimaryError = _ref$setPrimaryAddres.error,
    deleteUserAddressApi = _ref.deleteUserAddressApi,
    setPrimaryAddressApi = _ref.setPrimaryAddressApi,
    showModal = _ref.showModal,
    setShowModal = _ref.setShowModal;
  var errorMessage = (0, _getErrorMessage["default"])(userError || deleteAddressError || setPrimaryError);
  var addresses = (0, _get2["default"])(user, 'addresses', []);
  var nonPrimaryAddresses = (0, _filter2["default"])(addresses, {
    'isPrimary': false
  });
  var deleteRequestUserAddressId = (0, _get2["default"])(deleteAddressRequest, 'userAddressId');
  var primaryRequestUserAddressId = (0, _get2["default"])(setPrimaryAddressRequest, 'userAddressId');
  var userId = (0, _get2["default"])(user, 'userId');
  var primaryAddress = (0, _find2["default"])(addresses, {
    'isPrimary': true
  });
  var handleShow = function handleShow() {
    return setShowModal(true);
  };
  var handleClose = function handleClose() {
    return setShowModal(false);
  };
  return /*#__PURE__*/_react["default"].createElement(_Panel["default"], null, /*#__PURE__*/_react["default"].createElement(_Panel["default"].Heading, null, /*#__PURE__*/_react["default"].createElement(_Panel["default"].Title, null, "Address Information")), /*#__PURE__*/_react["default"].createElement(_Panel["default"].Body, null, errorMessage ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    bsStyle: "danger"
  }, errorMessage) : null, !isUserLoading && !(0, _isEmpty2["default"])(user) ? [/*#__PURE__*/_react["default"].createElement("address", {
    key: "0"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "Primary Address:"), /*#__PURE__*/_react["default"].createElement("br", null), primaryAddress ? (0, _formatAddress.formatAddress)(primaryAddress) : 'No primary address on file'), /*#__PURE__*/_react["default"].createElement("p", {
    key: "1"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "Other Addresses:")), /*#__PURE__*/_react["default"].createElement(_addAddressModal["default"], {
    editButtonStyle: editButtonStyle,
    userId: userId,
    showModal: showModal,
    handleClose: handleClose,
    key: "2"
  }), /*#__PURE__*/_react["default"].createElement(_ButtonGroup["default"], {
    style: {
      marginBottom: 11
    },
    key: "3"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "address-information--add-button",
    flat: true,
    bsStyle: editButtonStyle,
    bsSize: "small",
    style: {
      fontWeight: 'bold'
    },
    onClick: handleShow
  }, "Add New Location"))), /*#__PURE__*/_react["default"].createElement(_ListGroup["default"], {
    key: "4"
  }, (0, _map2["default"])(nonPrimaryAddresses, function (address) {
    var userAddressId = address.userAddressId,
      addressId = address.addressId;
    var deleteAddressIdMatch = deleteRequestUserAddressId === userAddressId;
    var primaryAddressIdMatch = primaryRequestUserAddressId === userAddressId;
    var isDeleteLoading = isDeleteAddressLoading && deleteAddressIdMatch;
    var isPrimaryLoading = isSetPrimaryLoading && primaryAddressIdMatch;
    var showErrorOnRow = !(0, _isEmpty2["default"])(deleteAddressError) && deleteAddressIdMatch || !(0, _isEmpty2["default"])(setPrimaryError) && primaryAddressIdMatch ? {
      bsStyle: 'danger'
    } : {};
    var deleteButtonId = "address-information--delete-".concat(userAddressId, "-button");
    var makePrimaryButtonId = "address-information--primary-".concat(userAddressId, "-button");
    return /*#__PURE__*/_react["default"].createElement(_ListGroupItem["default"], (0, _extends2["default"])({
      key: userAddressId,
      style: {
        padding: '20px 15px'
      }
    }, showErrorOnRow), (0, _formatAddress.formatAddress)(address), /*#__PURE__*/_react["default"].createElement(_ButtonToolbar["default"], {
      className: "btn-toolbar-right"
    }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      id: deleteButtonId,
      bsStyle: editButtonStyle,
      bsSize: "xsmall",
      ghost: true,
      onClick: function onClick() {
        return deleteUserAddressApi(userAddressId, addressId);
      },
      disabled: isDeleteLoading || isPrimaryLoading,
      loading: isDeleteLoading
    }, "Delete")), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      id: makePrimaryButtonId,
      bsStyle: editButtonStyle,
      bsSize: "xsmall",
      ghost: true,
      onClick: function onClick() {
        return setPrimaryAddressApi(userAddressId, addressId);
      },
      disabled: isPrimaryLoading || isDeleteLoading,
      loading: isPrimaryLoading
    }, "Make Primary"))));
  }))] : null));
};
AddressInformation.propTypes = {
  editButtonStyle: _propTypes["default"].string.isRequired,
  fetchUser: _propTypes["default"].shape({
    isLoading: _propTypes["default"].bool,
    response: _propTypes["default"].shape({
      addresses: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        userAddressId: _propTypes["default"].number.isRequired,
        addressId: _propTypes["default"].number.isRequired,
        firstLine: _propTypes["default"].string.isRequired,
        secondLine: _propTypes["default"].string,
        city: _propTypes["default"].string.isRequired,
        region: _propTypes["default"].string.isRequired,
        postalCode: _propTypes["default"].string.isRequired,
        isPrimary: _propTypes["default"].bool.isRequired
      }))
    }),
    error: _propTypes["default"].object
  }).isRequired,
  deleteUserAddress: _propTypes["default"].shape({
    isLoading: _propTypes["default"].bool,
    request: _propTypes["default"].shape({
      userAddressId: _propTypes["default"].number.isRequired
    }),
    error: _propTypes["default"].object
  }).isRequired,
  setPrimaryAddress: _propTypes["default"].shape({
    isLoading: _propTypes["default"].bool,
    request: _propTypes["default"].shape({
      userAddressId: _propTypes["default"].number.isRequired
    }),
    error: _propTypes["default"].object
  }).isRequired,
  deleteUserAddressApi: _propTypes["default"].func.isRequired,
  setPrimaryAddressApi: _propTypes["default"].func.isRequired,
  showModal: _propTypes["default"].bool.isRequired,
  setShowModal: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _compose["default"])((0, _withState["default"])('showModal', 'setShowModal', false), _pure["default"])(AddressInformation);
module.exports = exports.default;

/***/ }),

/***/ 4255:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 4256:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
var _typeof = __webpack_require__(46);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(2));
var _assign2 = _interopRequireDefault(__webpack_require__(2091));
var _head2 = _interopRequireDefault(__webpack_require__(696));
var _orderBy2 = _interopRequireDefault(__webpack_require__(2092));
var _get2 = _interopRequireDefault(__webpack_require__(5));
var _react = _interopRequireDefault(__webpack_require__(0));
var _propTypes = _interopRequireDefault(__webpack_require__(4));
var _reactRedux = __webpack_require__(16);
var _compose = _interopRequireDefault(__webpack_require__(7));
var _pure = _interopRequireDefault(__webpack_require__(6));
var _reduxForm = __webpack_require__(42);
var _formatAddress = __webpack_require__(2090);
var _ReduxForm = _interopRequireDefault(__webpack_require__(245));
var _Button = _interopRequireDefault(__webpack_require__(17));
var _Alert = _interopRequireDefault(__webpack_require__(33));
var _Modal = _interopRequireDefault(__webpack_require__(55));
var _angieslistAppPlatform = __webpack_require__(1);
var _getErrorMessage = _interopRequireDefault(__webpack_require__(264));
var _AddressComponent = _interopRequireDefault(__webpack_require__(4260));
var _addressComponentValidation = __webpack_require__(4290);
var memberMgmtActions = _interopRequireWildcard(__webpack_require__(578));
var myAccountUIActions = _interopRequireWildcard(__webpack_require__(579));
var _memberMgmtGatewayActionKeys = _interopRequireDefault(__webpack_require__(975));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var submit = function submit(_ref) {
  var addAddress = _ref.addAddress,
    reFetchUser = _ref.reFetchUser,
    changeCurrentAddress = _ref.changeCurrentAddress,
    values = _ref.values,
    userId = _ref.userId,
    userStore = _ref.userStore,
    handleClose = _ref.handleClose;
  var request = {
    userId: Number(userId),
    address: {
      makePrimary: values.makePrimary,
      firstLine: values.address.firstLine,
      secondLine: values.address.secondLine,
      city: values.address.city,
      regionAbbr: values.address.state,
      postalCode: values.address.zipCode
    }
  };
  addAddress(request).then(function () {
    reFetchUser(userId).then(function (reFetchUserResponse) {
      var newAddress = (0, _head2["default"])((0, _orderBy2["default"])((0, _get2["default"])(reFetchUserResponse, 'value.body.addresses', []), ['userAddressId'], ['desc']));

      // Note: At this time, we need to convert the "addressId: Number", to "addressId: String" and include "formattedAddress" so the Member Header Location bar display the new address correctly.
      var newAddressForMemberHeader = (0, _assign2["default"])({}, newAddress, {
        addressId: "".concat(newAddress.addressId),
        formattedAddress: (0, _formatAddress.formatAddress)(newAddress)
      });
      changeCurrentAddress(userStore, newAddressForMemberHeader);
    });
    handleClose();
  });
};
var AddAddressModal = function AddAddressModal(_ref2) {
  var userId = _ref2.userId,
    editButtonStyle = _ref2.editButtonStyle,
    handleSubmit = _ref2.handleSubmit,
    pristine = _ref2.pristine,
    invalid = _ref2.invalid,
    reFetchUser = _ref2.reFetchUser,
    userStore = _ref2.userStore,
    resetStore = _ref2.resetStore,
    changeCurrentAddress = _ref2.changeCurrentAddress,
    addAddress = _ref2.addAddress,
    _ref2$addAddressStore = _ref2.addAddressStore,
    isAddAddressLoading = _ref2$addAddressStore.isLoading,
    addAddressError = _ref2$addAddressStore.error,
    handleClose = _ref2.handleClose,
    showModal = _ref2.showModal;
  var errorMessage = (0, _getErrorMessage["default"])(addAddressError);
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    show: showModal,
    onHide: handleClose,
    backdrop: "static"
  }, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Header, {
    closeButton: true
  }, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Title, null, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "modal-title"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon icon-location"
  }), "Add New Location"))), /*#__PURE__*/_react["default"].createElement("form", {
    name: "add-address-modal",
    onSubmit: handleSubmit(function (values) {
      return submit({
        addAddress: addAddress,
        reFetchUser: reFetchUser,
        changeCurrentAddress: changeCurrentAddress,
        values: values,
        userId: userId,
        userStore: userStore,
        handleClose: handleClose
      });
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-body"
  }, errorMessage ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    bsStyle: "danger"
  }, errorMessage) : null, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "add-address-modal--make-primary",
    className: "control-label"
  }, "Make Primary:"), /*#__PURE__*/_react["default"].createElement(_ReduxForm["default"].Input, {
    id: "add-address-modal--make-primary",
    name: "makePrimary",
    type: "checkbox",
    label: "Check this to make it my primary location."
  }), /*#__PURE__*/_react["default"].createElement(_AddressComponent["default"], {
    showFieldWatermarkText: false
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-footer"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "add-address-modal--save-button",
    flat: true,
    bsStyle: editButtonStyle,
    bsSize: "small",
    type: "submit",
    disabled: pristine || invalid || isAddAddressLoading,
    loading: isAddAddressLoading
  }, "Save")), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "add-address-modal--close-button",
    flat: true,
    bsStyle: "tertiary",
    bsSize: "small",
    onClick: function onClick() {
      resetStore(_memberMgmtGatewayActionKeys["default"].ADD_ADDRESS_RESET);
      handleClose();
    }
  }, "Cancel")))));
};
AddAddressModal.propTypes = {
  editButtonStyle: _propTypes["default"].string.isRequired,
  userId: _propTypes["default"].number.isRequired,
  resetStore: _propTypes["default"].func.isRequired,
  reFetchUser: _propTypes["default"].func.isRequired,
  changeCurrentAddress: _propTypes["default"].func.isRequired,
  addAddress: _propTypes["default"].func.isRequired,
  addAddressStore: _propTypes["default"].shape({
    isLoading: _propTypes["default"].bool,
    error: _propTypes["default"].object
  }).isRequired,
  userStore: _propTypes["default"].object.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired,
  pristine: _propTypes["default"].bool.isRequired,
  invalid: _propTypes["default"].bool.isRequired,
  handleClose: _propTypes["default"].func.isRequired,
  showModal: _propTypes["default"].bool.isRequired
};
var AddAddressModalReduxForm = (0, _reduxForm.reduxForm)({
  form: 'add-address-modal',
  validate: function validate(values) {
    return {
      address: _angieslistAppPlatform.validation.validate(values.address, (0, _addressComponentValidation.getAddressComponentValidationRules)().address).invalidAttrs
    };
  }
})(AddAddressModal);
var _default = exports["default"] = (0, _compose["default"])((0, _reactRedux.connect)(function (state) {
  return {
    addAddressStore: state.memberManagementGateway.addAddress,
    userStore: state.user
  };
}, _objectSpread(_objectSpread({}, memberMgmtActions), myAccountUIActions)), _pure["default"])(AddAddressModalReduxForm);
module.exports = exports.default;

/***/ }),

/***/ 4260:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(34));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(2));

var _jsx2 = _interopRequireDefault(__webpack_require__(20));

var _get2 = _interopRequireDefault(__webpack_require__(5));

var _isEmpty2 = _interopRequireDefault(__webpack_require__(59));

var _reduce2 = _interopRequireDefault(__webpack_require__(1347));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _reduxForm = __webpack_require__(42);

var _compose = _interopRequireDefault(__webpack_require__(7));

var _pure = _interopRequireDefault(__webpack_require__(6));

var _Col = _interopRequireDefault(__webpack_require__(15));

var _Row = _interopRequireDefault(__webpack_require__(9));

var _forms = __webpack_require__(111);

var _StateSelect = _interopRequireDefault(__webpack_require__(582));

var _GooglePlacesAutocompleteComponent = _interopRequireDefault(__webpack_require__(4288));

var _span;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StateSelectField = (0, _forms.createFieldComponent)(_StateSelect.default);

var addColonAfterLabel = function addColonAfterLabel(text, addColonAfterText) {
  return addColonAfterText ? "".concat(text, ":") : text;
};

var markRequiredText = function markRequiredText(text, addAsteriskAfterText) {
  return addAsteriskAfterText ? /*#__PURE__*/(0, _jsx2.default)("span", {}, void 0, text, " ", _span || (_span = /*#__PURE__*/(0, _jsx2.default)("span", {
    className: "text-danger"
  }, void 0, "*"))) : text;
};

function AddressComponent(props) {
  /* -------------------- Setup -------------------- */
  var showFieldWatermarkText = props.showFieldWatermarkText,
      showFieldLabels = props.showFieldLabels,
      showRequiredFieldAsterisks = props.showRequiredFieldAsterisks,
      showColonAfterLabels = props.showColonAfterLabels,
      useAddressShortForm = props.useAddressShortForm,
      prefixNameForFieldIds = props.prefixNameForFieldIds,
      enableGoogleAutocomplete = props.enableGoogleAutocomplete,
      useStateAbbreviationValue = props.useStateAbbreviationValue,
      stateChooseText = props.stateChooseText,
      fieldLabels = props.fieldLabels,
      allFieldsTabIndex = props.allFieldsTabIndex;

  var _Object$assign = Object.assign({}, AddressComponent.defaultProps.fieldLabels, fieldLabels),
      firstLineLabelText = _Object$assign.firstLineLabelText,
      secondLineLabelText = _Object$assign.secondLineLabelText,
      cityLabelText = _Object$assign.cityLabelText,
      stateLabelText = _Object$assign.stateLabelText,
      zipCodeLabelText = _Object$assign.zipCodeLabelText;

  var firstLinePlaceholderAndLabelText = firstLineLabelText;
  var secondLinePlaceholderAndLabelText = secondLineLabelText;
  var cityPlaceholderAndLabelText = cityLabelText;
  var statePlaceholderAndLabelText = stateLabelText;
  var zipCodePlaceholderAndLabelText = zipCodeLabelText;
  var firstLineLabel = markRequiredText(addColonAfterLabel(firstLinePlaceholderAndLabelText, showColonAfterLabels), showRequiredFieldAsterisks);
  var secondLineLabel = addColonAfterLabel(secondLinePlaceholderAndLabelText, showColonAfterLabels);
  var cityLabel = markRequiredText(addColonAfterLabel(cityPlaceholderAndLabelText, showColonAfterLabels), showRequiredFieldAsterisks);
  var stateLabel = markRequiredText(addColonAfterLabel(statePlaceholderAndLabelText, showColonAfterLabels), showRequiredFieldAsterisks);
  var zipCodeLabel = markRequiredText(addColonAfterLabel(zipCodePlaceholderAndLabelText, showColonAfterLabels), showRequiredFieldAsterisks);
  var tabIndex = allFieldsTabIndex || 0;
  /* -------------------- Helpers -------------------- */

  function fillAddress(place) {
    var notUsingShortForm = !props.useAddressShortForm;
    var parentFormUpdateMethod = props.parentFormUpdateMethod;
    var addressPieces = (0, _reduce2.default)(place.address_components, function (addressMap, addressComponent) {
      return _objectSpread(_objectSpread({}, addressMap), {}, (0, _defineProperty2.default)({}, addressComponent.types[0], addressComponent.short_name));
    }, {});
    var addressPiecesNotEmpty = !(0, _isEmpty2.default)(addressPieces);

    if (addressPiecesNotEmpty) {
      var streetNumber = (0, _get2.default)(addressPieces, 'street_number', '');
      parentFormUpdateMethod('address.firstLine', "".concat(streetNumber, " ").concat(addressPieces.route));
      parentFormUpdateMethod('address.city', addressPieces.locality);
      parentFormUpdateMethod('address.zipCode', addressPieces.postal_code);

      if (notUsingShortForm) {
        parentFormUpdateMethod('address.state', addressPieces.administrative_area_level_1);
      }
    }
  }
  /* -------------------- Rendered Elements -------------------- */


  return /*#__PURE__*/(0, _jsx2.default)(_Row.default, {
    componentClass: _reduxForm.FormSection,
    name: props.name
  }, void 0, /*#__PURE__*/(0, _jsx2.default)(_Col.default, {
    xs: 12
  }, void 0, enableGoogleAutocomplete ? /*#__PURE__*/_react.default.createElement(_GooglePlacesAutocompleteComponent.default, (0, _extends2.default)({
    id: "".concat(prefixNameForFieldIds, "--first-line"),
    addressSelected: function addressSelected(place) {
      return fillAddress(place);
    },
    types: ['address'],
    restrictions: {
      country: 'us'
    },
    name: "firstLine",
    component: _forms.InputField,
    type: "text",
    tabIndex: tabIndex
  }, showFieldWatermarkText ? {
    placeholder: firstLinePlaceholderAndLabelText
  } : {}, showFieldLabels ? {
    label: firstLineLabel
  } : {})) : /*#__PURE__*/_react.default.createElement(_reduxForm.Field, (0, _extends2.default)({
    id: "".concat(prefixNameForFieldIds, "--first-line"),
    name: "firstLine",
    component: _forms.InputField,
    type: "text",
    autoComplete: "address-line1",
    tabIndex: tabIndex
  }, showFieldWatermarkText ? {
    placeholder: firstLinePlaceholderAndLabelText
  } : {}, showFieldLabels ? {
    label: firstLineLabel
  } : {})), !useAddressShortForm ? /*#__PURE__*/_react.default.createElement(_reduxForm.Field, (0, _extends2.default)({
    id: "".concat(prefixNameForFieldIds, "--second-line"),
    name: "secondLine",
    component: _forms.InputField,
    type: "text",
    tabIndex: tabIndex
  }, showFieldWatermarkText ? {
    placeholder: secondLinePlaceholderAndLabelText
  } : {}, showFieldLabels ? {
    label: secondLineLabel
  } : {})) : null), /*#__PURE__*/_react.default.createElement(_Col.default, (0, _extends2.default)({
    xs: 12
  }, !useAddressShortForm ? {
    sm: 4
  } : {}), /*#__PURE__*/_react.default.createElement(_reduxForm.Field, (0, _extends2.default)({
    id: "".concat(prefixNameForFieldIds, "--city"),
    name: "city",
    component: _forms.InputField,
    type: "text",
    tabIndex: tabIndex
  }, showFieldWatermarkText ? {
    placeholder: cityPlaceholderAndLabelText
  } : {}, showFieldLabels ? {
    label: cityLabel
  } : {}))), !useAddressShortForm ? /*#__PURE__*/(0, _jsx2.default)(_Col.default, {
    xs: 12,
    sm: 4
  }, void 0, /*#__PURE__*/_react.default.createElement(_reduxForm.Field, (0, _extends2.default)({
    id: "".concat(prefixNameForFieldIds, "--state"),
    name: "state",
    component: StateSelectField,
    useAbbreviationValue: useStateAbbreviationValue,
    chooseText: stateChooseText,
    tabIndex: tabIndex
  }, showFieldLabels ? {
    label: stateLabel
  } : {}))) : null, /*#__PURE__*/_react.default.createElement(_Col.default, (0, _extends2.default)({
    xs: 12
  }, !useAddressShortForm ? {
    sm: 4
  } : {}), /*#__PURE__*/_react.default.createElement(_reduxForm.Field, (0, _extends2.default)({
    id: "".concat(prefixNameForFieldIds, "--zip-code"),
    name: "zipCode",
    component: _forms.InputField,
    type: "tel",
    tabIndex: tabIndex
  }, showFieldWatermarkText ? {
    placeholder: zipCodePlaceholderAndLabelText
  } : {}, showFieldLabels ? {
    label: zipCodeLabel
  } : {}))));
}

AddressComponent.defaultProps = {
  name: 'address',
  // Note: 'address' value should not change, or you will break the validation rules
  showFieldLabels: true,
  showFieldWatermarkText: true,
  showRequiredFieldAsterisks: true,
  showColonAfterLabels: true,
  useAddressShortForm: false,
  prefixNameForFieldIds: 'address-component',
  parentFormUpdateMethod: function parentFormUpdateMethod(fieldName, value) {},
  enableGoogleAutocomplete: false,
  useStateAbbreviationValue: true,
  stateChooseText: 'Select One',
  fieldLabels: {
    firstLineLabelText: 'Street Address 1',
    secondLineLabelText: 'Street Address 2',
    cityLabelText: 'City',
    stateLabelText: 'State',
    zipCodeLabelText: 'Zip Code'
  }
};

// Composition and Exports
var _default = (0, _compose.default)(_pure.default)(AddressComponent);

exports.default = _default;
module.exports = exports.default;

/***/ }),

/***/ 4288:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(34));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(88));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _inherits2 = _interopRequireDefault(__webpack_require__(14));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(12));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));

var _findIndex2 = _interopRequireDefault(__webpack_require__(547));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

__webpack_require__(4289);

var _reduxForm = __webpack_require__(42);

var _reactDom = _interopRequireDefault(__webpack_require__(64));

var _excluded = ["addressSelected", "types", "restrictions"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Note that use of GoogleAutocomplete needs to be approved through Product and Ops due to the inherent cost
var GoogleAutocomplete = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(GoogleAutocomplete, _React$Component);

  var _super = _createSuper(GoogleAutocomplete);

  function GoogleAutocomplete(props) {
    var _this;

    (0, _classCallCheck2.default)(this, GoogleAutocomplete);
    _this = _super.call(this, props);
    _this.google = null;
    _this.autocomplete = null;
    _this.placeChangeEvent = null;
    _this.keyDownEvent = null;
    _this.input = null;
    return _this;
  }

  (0, _createClass2.default)(GoogleAutocomplete, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          _this$props$types = _this$props.types,
          types = _this$props$types === void 0 ? ['address'] : _this$props$types,
          restrictions = _this$props.restrictions;
      var config = {
        types: types
      };

      if (true) {
        this.google = window.google;

        if (this.google.maps) {
          this.input = _reactDom.default.findDOMNode(this.refs.input).querySelector('input');
          this.autocomplete = new this.google.maps.places.Autocomplete(this.input, config);
          this.placeChangeEvent = this.autocomplete.addListener('place_changed', this.onSelected.bind(this));
          this.keyDownEvent = this.input.addEventListener('keydown', this.stopSubmitOnSelect.bind(this));

          if (restrictions) {
            this.autocomplete.setComponentRestrictions(restrictions);
          }

          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.geolocate.bind(this));
          }
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.placeChangeEvent) {
        this.placeChangeEvent.remove();
      }

      if (this.keyDownEvent) {
        this.keyDownEvent.remove();
      }
    }
  }, {
    key: "onSelected",
    value: function onSelected() {
      if (this.props.addressSelected) {
        this.props.addressSelected(this.autocomplete.getPlace());
      }
    }
  }, {
    key: "geolocate",
    value: function geolocate(position) {
      var geoloc = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
        accuracy: position.coords.accuracy
      };
      this.autocomplete.setBounds({
        east: geoloc.lng,
        north: geoloc.lat,
        south: geoloc.lat,
        west: geoloc.lng
      });
    }
  }, {
    key: "stopSubmitOnSelect",
    value: function stopSubmitOnSelect(event) {
      var _this2 = this;

      if (event.keyCode === 13 && event.srcElement.name === this.input.name) {
        event.preventDefault();
        event.srcElement.blur();
        var indexOfAutocomplete = (0, _findIndex2.default)(event.srcElement.form, function (element) {
          return element.name === _this2.input.name;
        }); // hack to move focus off of autocomplete element to allow submit on enter

        if (indexOfAutocomplete < event.srcElement.form.length - 1) {
          event.srcElement.form[indexOfAutocomplete + 1].focus();
        } else {
          event.srcElement.form[indexOfAutocomplete - 1].focus();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          addressSelected = _this$props2.addressSelected,
          types = _this$props2.types,
          restrictions = _this$props2.restrictions,
          other = (0, _objectWithoutProperties2.default)(_this$props2, _excluded);
      return /*#__PURE__*/_react.default.createElement(_reduxForm.Field, (0, _extends2.default)({}, other, {
        id: "".concat(other.id),
        key: "".concat(other.id, "-google-autocomplete"),
        ref: "input",
        type: "text"
      }));
    }
  }]);
  return GoogleAutocomplete;
}(_react.default.Component);

exports.default = GoogleAutocomplete;
module.exports = exports.default;

/***/ }),

/***/ 4289:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 4290:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shortFormAddressComponentValidation = exports.getAddressComponentValidationRules = exports.defaultAddressComponentValidation = void 0;
var defaultAddressComponentValidation = {
  address: {
    firstLine: {
      required: true,
      maxLength: 254,
      title: true
    },
    secondLine: {
      required: false,
      maxLength: 254,
      title: true
    },
    city: {
      required: true,
      maxLength: 254,
      city: true
    },
    state: {
      required: true
    },
    zipCode: {
      required: true,
      maxLength: 5,
      pattern: 'postalCode'
    }
  }
};
exports.defaultAddressComponentValidation = defaultAddressComponentValidation;
var shortFormAddressComponentValidation = {
  address: {
    firstLine: {
      required: true,
      maxLength: 254,
      title: true
    },
    city: {
      required: true,
      maxLength: 254,
      city: true
    },
    zipCode: {
      required: true,
      maxLength: 5,
      pattern: 'postalCode'
    }
  }
};
exports.shortFormAddressComponentValidation = shortFormAddressComponentValidation;

var getAddressComponentValidationRules = function getAddressComponentValidationRules() {
  var usingShortFormRules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return usingShortFormRules ? shortFormAddressComponentValidation : defaultAddressComponentValidation;
};

exports.getAddressComponentValidationRules = getAddressComponentValidationRules;

/***/ }),

/***/ 4291:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(0));
var _propTypes = _interopRequireDefault(__webpack_require__(4));
var _compose = _interopRequireDefault(__webpack_require__(7));
var _pure = _interopRequireDefault(__webpack_require__(6));
var _withState = _interopRequireDefault(__webpack_require__(1314));
var _angieslistAppPlatform = __webpack_require__(1);
var _Button = _interopRequireDefault(__webpack_require__(17));
var _Panel = _interopRequireDefault(__webpack_require__(177));
var _ButtonToolbar = _interopRequireDefault(__webpack_require__(204));
var _ButtonGroup = _interopRequireDefault(__webpack_require__(705));
var _contactPreferencesModal = _interopRequireDefault(__webpack_require__(4292));
var ContactPreferences = function ContactPreferences(_ref) {
  var userId = _ref.userId,
    email = _ref.email,
    editButtonStyle = _ref.editButtonStyle,
    cancelButtonStyle = _ref.cancelButtonStyle,
    showContactPrefModal = _ref.showContactPrefModal,
    showModal = _ref.showModal,
    setShowModal = _ref.setShowModal;
  var handleShow = function handleShow() {
    return setShowModal(true);
  };
  var handleClose = function handleClose() {
    return setShowModal(false);
  };
  return /*#__PURE__*/_react["default"].createElement(_Panel["default"], null, /*#__PURE__*/_react["default"].createElement(_Panel["default"].Heading, null, /*#__PURE__*/_react["default"].createElement(_Panel["default"].Title, null, "Email & Phone Preferences")), /*#__PURE__*/_react["default"].createElement(_Panel["default"].Body, null, /*#__PURE__*/_react["default"].createElement("p", null, "Choose how you'd like to receive alerts and information from Angi."), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_ButtonToolbar["default"], null, /*#__PURE__*/_react["default"].createElement(_contactPreferencesModal["default"], {
    userId: userId,
    email: email,
    editButtonStyle: editButtonStyle,
    cancelButtonStyle: cancelButtonStyle,
    showModalOverlay: showContactPrefModal,
    showModal: showModal,
    handleClose: handleClose
  }), /*#__PURE__*/_react["default"].createElement(_ButtonGroup["default"], null, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "contact-preferences--edit-button",
    bsSize: "small",
    flat: true,
    bsStyle: editButtonStyle,
    style: {
      fontWeight: 'bold'
    },
    onClick: handleShow
  }, "Manage Preferences"))))));
};
ContactPreferences.propTypes = {
  editButtonStyle: _propTypes["default"].string.isRequired,
  cancelButtonStyle: _propTypes["default"].string.isRequired,
  email: _propTypes["default"].string,
  userId: _propTypes["default"].string,
  showContactPrefModal: _propTypes["default"].bool.isRequired,
  showModal: _propTypes["default"].bool.isRequired,
  setShowModal: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _compose["default"])((0, _withState["default"])('showModal', 'setShowModal', false), _pure["default"])(ContactPreferences);
module.exports = exports.default;

/***/ }),

/***/ 4292:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
var _typeof = __webpack_require__(46);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(2));
var _fromPairs2 = _interopRequireDefault(__webpack_require__(2099));
var _map2 = _interopRequireDefault(__webpack_require__(77));
var _get4 = _interopRequireDefault(__webpack_require__(5));
__webpack_require__(4293);
var _react = _interopRequireDefault(__webpack_require__(0));
var _propTypes = _interopRequireDefault(__webpack_require__(4));
var _reactRedux = __webpack_require__(16);
var _compose = _interopRequireDefault(__webpack_require__(7));
var _pure = _interopRequireDefault(__webpack_require__(6));
var _reduxForm = __webpack_require__(42);
var _Row = _interopRequireDefault(__webpack_require__(9));
var _Col = _interopRequireDefault(__webpack_require__(15));
var _Alert = _interopRequireDefault(__webpack_require__(33));
var _Button = _interopRequireDefault(__webpack_require__(17));
var _ListGroup = _interopRequireDefault(__webpack_require__(580));
var _ListGroupItem = _interopRequireDefault(__webpack_require__(581));
var _ReduxForm = _interopRequireDefault(__webpack_require__(245));
var _Modal = _interopRequireDefault(__webpack_require__(55));
var _angieslistAppPlatform = __webpack_require__(1);
var _getErrorMessage = _interopRequireDefault(__webpack_require__(264));
var memberMgmtGatewayActions = _interopRequireWildcard(__webpack_require__(578));
var serviceProviderGatewayActions = _interopRequireWildcard(__webpack_require__(979));
var myAccountUIActions = _interopRequireWildcard(__webpack_require__(579));
var _contactPreferenceCopy = _interopRequireDefault(__webpack_require__(2101));
var _fixContactPrefLinks = __webpack_require__(2102);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var submit = function submit(userId, values, handleClose, saveUserContactPreferences, saveAssociateContactPreferences, appName) {
  var preferences = (0, _map2["default"])(values, function (value, k) {
    return {
      key: k,
      enabled: value
    };
  });
  var params = {
    userId: Number(userId),
    preferences: preferences
  };
  var gateWayActions = appName === 'member-app' ? saveUserContactPreferences : saveAssociateContactPreferences;
  gateWayActions(params).then(function () {
    handleClose();
  });
};
var ContactPreferencesModal = function ContactPreferencesModal(_ref) {
  var dirty = _ref.dirty,
    pristine = _ref.pristine,
    invalid = _ref.invalid,
    editButtonStyle = _ref.editButtonStyle,
    cancelButtonStyle = _ref.cancelButtonStyle,
    handleSubmit = _ref.handleSubmit,
    userId = _ref.userId,
    email = _ref.email,
    gateWay = _ref.gateWay,
    saveUserContactPreferences = _ref.saveUserContactPreferences,
    saveAssociateContactPreferences = _ref.saveAssociateContactPreferences,
    appName = _ref.appName,
    handleClose = _ref.handleClose,
    showModal = _ref.showModal;
  var _get2 = (0, _get4["default"])(gateWay, 'getContactPreferences'),
    isContactPreferenceLoading = _get2.isLoading,
    getContactPreferencesError = _get2.error,
    contactPrefsResponse = _get2.response;
  var _get3 = (0, _get4["default"])(gateWay, 'saveContactPreferences'),
    isSaveContactPreferencesLoading = _get3.isLoading,
    saveContactPreferencesError = _get3.error;
  var errorMessage = (0, _getErrorMessage["default"])(getContactPreferencesError || saveContactPreferencesError);
  var contactPreferences = (0, _map2["default"])((0, _get4["default"])(contactPrefsResponse, 'preferences', []), function (pref) {
    return (0, _fixContactPrefLinks.fixContactPrefLinks)(pref, appName);
  });
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    show: showModal,
    onHide: handleClose,
    className: "account-modal email-preferences",
    id: "contact-preferences-modal",
    backdrop: "static"
  }, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Header, {
    closeButton: true
  }, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Title, null, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "modal-title"
  }, "Email & Phone Preferences"))), /*#__PURE__*/_react["default"].createElement("form", {
    name: "contact-preferences",
    onSubmit: handleSubmit(function (values) {
      submit(userId, values, handleClose, saveUserContactPreferences, saveAssociateContactPreferences, appName);
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "account-modal email-pref-modal-content"
  }, errorMessage ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    bsStyle: "danger"
  }, errorMessage) : null, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_contactPreferenceCopy["default"], {
    email: email
  }))), /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_ListGroup["default"], null, (0, _map2["default"])(contactPreferences, function (_ref2) {
    var key = _ref2.key,
      displayName = _ref2.displayName,
      description = _ref2.description,
      rank = _ref2.rank;
    return /*#__PURE__*/_react["default"].createElement(_ListGroupItem["default"], {
      key: rank
    }, /*#__PURE__*/_react["default"].createElement(_ReduxForm["default"].Input, {
      name: key,
      type: "checkbox",
      id: "contact-preferences-modal--checkbox-id".concat(rank),
      label: /*#__PURE__*/_react["default"].createElement("b", null, displayName)
    }), description);
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-footer"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "contact-preferences-modal--save-button",
    flat: true,
    bsStyle: editButtonStyle,
    disabled: pristine || invalid || isContactPreferenceLoading,
    loading: isContactPreferenceLoading || isSaveContactPreferencesLoading,
    bsSize: "small",
    type: "submit"
  }, "Save")), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "contact-preferences-modal--cancel-button",
    flat: true,
    bsSize: "small",
    bsStyle: cancelButtonStyle,
    onClick: function onClick() {
      return handleClose();
    }
  }, "Cancel")))));
};
ContactPreferencesModal.propTypes = {
  editButtonStyle: _propTypes["default"].string.isRequired,
  cancelButtonStyle: _propTypes["default"].string.isRequired,
  userId: _propTypes["default"].string,
  email: _propTypes["default"].string,
  gateWay: _propTypes["default"].object,
  saveUserContactPreferences: _propTypes["default"].func.isRequired,
  saveAssociateContactPreferences: _propTypes["default"].func.isRequired,
  appName: _propTypes["default"].string.isRequired,
  // redux form
  dirty: _propTypes["default"].bool.isRequired,
  pristine: _propTypes["default"].bool.isRequired,
  invalid: _propTypes["default"].bool.isRequired,
  reset: _propTypes["default"].func.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired,
  handleClose: _propTypes["default"].func.isRequired,
  showModal: _propTypes["default"].bool.isRequired
};
var ContactPreferencesModalReduxForm = (0, _reduxForm.reduxForm)({
  form: 'contact-preferences',
  enableReinitialize: true
})(ContactPreferencesModal);
var _default = exports["default"] = (0, _compose["default"])((0, _reactRedux.connect)(function (state, props) {
  var gateWay = state.config.appName === 'office-app' ? state.serviceProviderGateway : state.memberManagementGateway;
  var getContactPreferences = (0, _get4["default"])(gateWay, 'getContactPreferences.response.preferences', {});
  var keyValuesArray = (0, _map2["default"])(getContactPreferences, function (pref) {
    return [pref.key, pref.enabled];
  });
  var fieldValues = (0, _fromPairs2["default"])(keyValuesArray);
  return {
    gateWay: gateWay,
    serviceProviderGateway: state.serviceProviderGateway,
    appName: state.config.appName,
    initialValues: fieldValues
  };
}, _objectSpread(_objectSpread(_objectSpread({}, memberMgmtGatewayActions), serviceProviderGatewayActions), myAccountUIActions)), _pure["default"])(ContactPreferencesModalReduxForm);
module.exports = exports.default;

/***/ }),

/***/ 4293:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 4294:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _angieslistAppPlatform = __webpack_require__(1);
var serviceProviderGatewayService = {
  getAssociateContactPreferences: function getAssociateContactPreferences(userId) {
    return _angieslistAppPlatform.httpClient.get("/gateway/service-provider/v1/associate/".concat(userId, "/preferences"));
  },
  saveAssociateContactPreferences: function saveAssociateContactPreferences(data) {
    return _angieslistAppPlatform.httpClient.post('/gateway/service-provider/v1/associate/preferences', {
      body: data
    });
  },
  getAssociateContactPreferencesByEmail: function getAssociateContactPreferencesByEmail(email, apiToken, serviceProviderId) {
    var serviceProviderIdQueryString = serviceProviderId ? '&serviceProviderId=' + serviceProviderId : '';
    return _angieslistAppPlatform.httpClient.get("/gateway/service-provider/v1/associate/preferences?email=".concat(email).concat(serviceProviderIdQueryString), {
      headers: {
        Authorization: apiToken
      }
    });
  },
  saveAssociateContactPreferencesByEmail: function saveAssociateContactPreferencesByEmail(_ref) {
    var email = _ref.email,
      apiToken = _ref.apiToken,
      preferences = _ref.preferences,
      serviceProviderId = _ref.serviceProviderId;
    return _angieslistAppPlatform.httpClient.post('/gateway/service-provider/v1/associate/preferences/unauth', {
      body: {
        email: email,
        preferences: preferences,
        serviceProviderId: serviceProviderId
      },
      headers: {
        Authorization: apiToken
      }
    });
  }
};
var _default = exports["default"] = serviceProviderGatewayService;
module.exports = exports.default;

/***/ }),

/***/ 4299:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
var _typeof = __webpack_require__(46);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(2));
var _extends2 = _interopRequireDefault(__webpack_require__(34));
var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));
var _createClass2 = _interopRequireDefault(__webpack_require__(11));
var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(12));
var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
var _inherits2 = _interopRequireDefault(__webpack_require__(14));
var _isEmpty2 = _interopRequireDefault(__webpack_require__(59));
var _get2 = _interopRequireDefault(__webpack_require__(5));
var _react = _interopRequireDefault(__webpack_require__(0));
var _reactHelmetAsync = _interopRequireDefault(__webpack_require__(58));
var _Grid = _interopRequireDefault(__webpack_require__(41));
var _Row = _interopRequireDefault(__webpack_require__(9));
var _Col = _interopRequireDefault(__webpack_require__(15));
var _compose = _interopRequireDefault(__webpack_require__(7));
var _pure = _interopRequireDefault(__webpack_require__(6));
var _reactRedux = __webpack_require__(16);
var _withRouter = _interopRequireDefault(__webpack_require__(496));
var _propTypes = _interopRequireDefault(__webpack_require__(4));
var _contactPreferences = _interopRequireDefault(__webpack_require__(4300));
var _updateContactPreferences = __webpack_require__(2107);
var _angieslistAppPlatform = __webpack_require__(1);
var _contactPreferences2 = __webpack_require__(2105);
var _contactPreferences3 = _interopRequireDefault(__webpack_require__(4304));
var serviceProviderGatewayActions = _interopRequireWildcard(__webpack_require__(979));
var _contactPreferencesStyles = _interopRequireDefault(__webpack_require__(4305));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var title = 'Business Center - Contact Preferences';

/* eslint react/prefer-stateless-function: 0 */
var ContactPreferencesContainer = /*#__PURE__*/function (_React$Component) {
  function ContactPreferencesContainer() {
    (0, _classCallCheck2["default"])(this, ContactPreferencesContainer);
    return _callSuper(this, ContactPreferencesContainer, arguments);
  }
  (0, _inherits2["default"])(ContactPreferencesContainer, _React$Component);
  return (0, _createClass2["default"])(ContactPreferencesContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        searchQuery = _this$props.location.search,
        apiToken = _this$props.apiToken,
        getAssociateContactPreferencesByEmail = _this$props.getAssociateContactPreferencesByEmail,
        unsubscribeFromAssociateContactPreferenceByEmail = _this$props.unsubscribeFromAssociateContactPreferenceByEmail;
      var parsedEmail = (0, _contactPreferences2.parseQueryParam)(searchQuery, 'email');
      var prefType = (0, _contactPreferences2.parseQueryParam)(searchQuery, 'prefType');
      var serviceProviderId = (0, _contactPreferences2.parseNumberFromQueryParam)(searchQuery, 'SPID');
      var emailIsValid = (0, _updateContactPreferences.validateEmail)(parsedEmail);
      if (emailIsValid) {
        var encodedEmail = (0, _contactPreferences2.encodedQueryParam)(searchQuery, 'email');
        getAssociateContactPreferencesByEmail(encodedEmail, apiToken, serviceProviderId).then(function () {
          if (!(0, _isEmpty2["default"])(prefType)) {
            unsubscribeFromAssociateContactPreferenceByEmail({
              email: parsedEmail,
              apiToken: apiToken,
              preferences: [{
                key: prefType,
                enabled: false
              }],
              serviceProviderId: serviceProviderId
            });
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var searchQuery = (0, _get2["default"])(this.props, 'location.search');
      var email = (0, _contactPreferences2.parseQueryParam)(searchQuery, 'email');
      var serviceProviderId = (0, _contactPreferences2.parseNumberFromQueryParam)(searchQuery, 'SPID');
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        style: _contactPreferencesStyles["default"].pageBackground
      }), /*#__PURE__*/_react["default"].createElement(_reactHelmetAsync["default"], null, /*#__PURE__*/_react["default"].createElement("title", null, title)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], null, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_contactPreferences3["default"], (0, _extends2["default"])({}, this.props, {
        email: email,
        serviceProviderId: serviceProviderId
      }))))));
    }
  }]);
}(_react["default"].Component);
ContactPreferencesContainer.propTypes = {
  apiToken: _propTypes["default"].string.isRequired,
  appName: _propTypes["default"].string.isRequired,
  getAssociateContactPreferencesByEmail: _propTypes["default"].func.isRequired,
  unsubscribeFromAssociateContactPreferenceByEmail: _propTypes["default"].func.isRequired,
  // react-router
  location: _propTypes["default"].object
};
var _default = exports["default"] = (0, _compose["default"])((0, _angieslistAppPlatform.analytics)({
  ruleset: _contactPreferences["default"]
}), _withRouter["default"], (0, _reactRedux.connect)(function (state, props) {
  return {
    apiToken: state.config.contactPreferenceApiToken,
    serviceProviderGateway: state.serviceProviderGateway,
    memberManagementGateway: state.memberManagementGateway,
    appName: state.config.appName
  };
}, _objectSpread({}, serviceProviderGatewayActions)), _pure["default"])(ContactPreferencesContainer);
module.exports = exports.default;

/***/ }),

/***/ 4300:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(2));
var _defaultAnalyticsProps = __webpack_require__(2043);
var _contactPreferenceProps = __webpack_require__(4301);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var activityLocation = 'SP : Email Unsubscribe';
var _default = exports["default"] = {
  page: {
    name: activityLocation,
    properties: _objectSpread(_objectSpread(_objectSpread({}, _defaultAnalyticsProps.defaultPageProps), {}, {
      name: activityLocation,
      title: 'Business Center - Email Unsubscribe'
    }, _contactPreferenceProps.contactPreferenceProps), _contactPreferenceProps.contactPreferencePageProps)
  },
  elements: {
    'contact-preferences-form--save-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread(_objectSpread({
          activityLocation: activityLocation,
          description: 'Save Contact Preferences'
        }, _defaultAnalyticsProps.defaultProps), _contactPreferenceProps.contactPreferenceProps)
      }
    }
  }
};
module.exports = exports.default;

/***/ }),

/***/ 4301:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contactPreferenceProps = exports.contactPreferencePageProps = void 0;
var _get2 = _interopRequireDefault(__webpack_require__(5));
var _contactPreferences = __webpack_require__(2105);
var _queryString = _interopRequireDefault(__webpack_require__(65));
var contactPreferenceProps = exports.contactPreferenceProps =  true ? {
  email: (0, _contactPreferences.parseQueryParam)(window.location.search, 'email')
} : {};
var contactPreferencePageProps = exports.contactPreferencePageProps =  true ? {
  jobid: (0, _get2["default"])(_queryString["default"].parse(window.location.search), 'jobid')
} : {};

/***/ }),

/***/ 4302:
/***/ (function(module, exports, __webpack_require__) {

var isNumber = __webpack_require__(1796);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),

/***/ 4303:
/***/ (function(module, exports, __webpack_require__) {

var isObjectLike = __webpack_require__(222),
    isPlainObject = __webpack_require__(408);

/**
 * Checks if `value` is likely a DOM element.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
 * @example
 *
 * _.isElement(document.body);
 * // => true
 *
 * _.isElement('<body>');
 * // => false
 */
function isElement(value) {
  return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
}

module.exports = isElement;


/***/ }),

/***/ 4304:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
var _typeof = __webpack_require__(46);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ContactPreferences = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(2));
var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));
var _createClass2 = _interopRequireDefault(__webpack_require__(11));
var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(12));
var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
var _inherits2 = _interopRequireDefault(__webpack_require__(14));
var _find2 = _interopRequireDefault(__webpack_require__(79));
var _head2 = _interopRequireDefault(__webpack_require__(696));
var _fromPairs2 = _interopRequireDefault(__webpack_require__(2099));
var _map2 = _interopRequireDefault(__webpack_require__(77));
var _get5 = _interopRequireDefault(__webpack_require__(5));
var _react = _interopRequireDefault(__webpack_require__(0));
var _propTypes = _interopRequireDefault(__webpack_require__(4));
var _compose = _interopRequireDefault(__webpack_require__(7));
var _pure = _interopRequireDefault(__webpack_require__(6));
var _angieslistAppPlatform = __webpack_require__(1);
var _updateContactPreferences = __webpack_require__(2107);
var _Alert = _interopRequireDefault(__webpack_require__(33));
var _Button = _interopRequireDefault(__webpack_require__(17));
var _Panel = _interopRequireDefault(__webpack_require__(177));
var _ListGroup = _interopRequireDefault(__webpack_require__(580));
var _ListGroupItem = _interopRequireDefault(__webpack_require__(581));
var _ReduxForm = _interopRequireDefault(__webpack_require__(245));
var _reactRedux = __webpack_require__(16);
var memberMgmtGatewayActions = _interopRequireWildcard(__webpack_require__(578));
var serviceProviderGatewayActions = _interopRequireWildcard(__webpack_require__(979));
var myAccountUIActions = _interopRequireWildcard(__webpack_require__(579));
var _reduxForm = __webpack_require__(42);
var _contactPreferenceCopy = _interopRequireDefault(__webpack_require__(2101));
var _fixContactPrefLinks = __webpack_require__(2102);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var pageHeader = 'Email & Phone Preferences';
var displayUnsubscribeSuccessMessage = function displayUnsubscribeSuccessMessage(preferenceName) {
  return /*#__PURE__*/_react["default"].createElement("span", null, "You have been unsubscribed from ", /*#__PURE__*/_react["default"].createElement("em", null, preferenceName));
};
var saveSuccessMessage = /*#__PURE__*/_react["default"].createElement("em", null, "Your preferences have been updated. It may take up to 5 days for this update to take effect");
var ContactPreferences = exports.ContactPreferences = /*#__PURE__*/function (_React$Component) {
  function ContactPreferences() {
    (0, _classCallCheck2["default"])(this, ContactPreferences);
    return _callSuper(this, ContactPreferences, arguments);
  }
  (0, _inherits2["default"])(ContactPreferences, _React$Component);
  return (0, _createClass2["default"])(ContactPreferences, [{
    key: "submit",
    value: function submit(_ref) {
      var email = _ref.email,
        serviceProviderId = _ref.serviceProviderId,
        values = _ref.values,
        appName = _ref.appName,
        apiToken = _ref.apiToken,
        saveUserContactPreferencesByEmail = _ref.saveUserContactPreferencesByEmail,
        saveAssociateContactPreferencesByEmail = _ref.saveAssociateContactPreferencesByEmail;
      var preferences = (0, _map2["default"])(values, function (value, k) {
        return {
          key: k,
          enabled: value
        };
      });
      var params = {
        email: email,
        apiToken: apiToken,
        preferences: preferences
      };
      if (appName === 'member-app') {
        saveUserContactPreferencesByEmail(params);
      } else {
        saveAssociateContactPreferencesByEmail(_objectSpread(_objectSpread({}, params), {}, {
          serviceProviderId: serviceProviderId
        }));
      }
    }
  }, {
    key: "resetSavedForm",
    value: function resetSavedForm(appName, resetSaveUserContactPreferencesByEmail, resetSaveAssociateContactPreferencesByEmail) {
      var resetAction = appName === 'member-app' ? resetSaveUserContactPreferencesByEmail : resetSaveAssociateContactPreferencesByEmail;
      resetAction();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        pristine = _this$props.pristine,
        invalid = _this$props.invalid,
        email = _this$props.email,
        serviceProviderId = _this$props.serviceProviderId,
        gateWay = _this$props.gateWay,
        apiToken = _this$props.apiToken,
        appName = _this$props.appName,
        handleSubmit = _this$props.handleSubmit,
        saveUserContactPreferencesByEmail = _this$props.saveUserContactPreferencesByEmail,
        saveAssociateContactPreferencesByEmail = _this$props.saveAssociateContactPreferencesByEmail,
        resetSaveUserContactPreferencesByEmail = _this$props.resetSaveUserContactPreferencesByEmail,
        resetSaveAssociateContactPreferencesByEmail = _this$props.resetSaveAssociateContactPreferencesByEmail;
      var _get2 = (0, _get5["default"])(gateWay, 'getContactPreferencesByEmail'),
        isContactPreferenceLoading = _get2.isLoading,
        getContactPreferencesError = _get2.error,
        contactPrefsResponse = _get2.response;
      var _get3 = (0, _get5["default"])(gateWay, 'saveContactPreferencesByEmail'),
        isSaveContactPreferencesLoading = _get3.isLoading,
        saveContactPreferencesError = _get3.error,
        saveContactPreferencesResponse = _get3.response;
      var _get4 = (0, _get5["default"])(gateWay, 'unsubscribeFromContactPreferenceByEmail'),
        unsubscribeContactPreferenceRequest = _get4.request,
        unsubscribeContactPreferenceError = _get4.error;
      var unsubscribedPreference = (0, _head2["default"])((0, _get5["default"])(unsubscribeContactPreferenceRequest, 'params.preferences', []));
      var contactPreferences = (0, _map2["default"])((0, _get5["default"])(contactPrefsResponse, 'preferences', []), function (pref) {
        return (0, _fixContactPrefLinks.fixContactPrefLinks)(pref, appName);
      }).filter(function (pref) {
        return pref.key !== 'marketing_sms';
      });
      var emailIsValid = (0, _updateContactPreferences.validateEmail)(email);
      var unsubscribedPrefType = null;
      if (unsubscribedPreference) {
        unsubscribedPrefType = (0, _find2["default"])(contactPreferences, function (p) {
          return p.key === unsubscribedPreference.key;
        });
      }
      var hasUnsubscribed = unsubscribedPrefType && !unsubscribeContactPreferenceError;
      var hasSavedChanges = saveContactPreferencesResponse && !saveContactPreferencesError;
      var saveButtonStyle = appName === 'office-app' ? 'primary-office' : 'primary';
      return /*#__PURE__*/_react["default"].createElement(_Panel["default"], null, /*#__PURE__*/_react["default"].createElement(_Panel["default"].Body, null, /*#__PURE__*/_react["default"].createElement("h1", {
        className: "h3"
      }, pageHeader), !emailIsValid || getContactPreferencesError ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
        bsStyle: "danger"
      }, (0, _angieslistAppPlatform.getErrorMessage)(getContactPreferencesError || {})) : /*#__PURE__*/_react["default"].createElement("form", {
        name: "contact-preferences-unsubscribe",
        onSubmit: handleSubmit(function (values) {
          _this.submit({
            email: email,
            serviceProviderId: serviceProviderId,
            values: values,
            appName: appName,
            apiToken: apiToken,
            saveUserContactPreferencesByEmail: saveUserContactPreferencesByEmail,
            saveAssociateContactPreferencesByEmail: saveAssociateContactPreferencesByEmail
          });
        })
      }, unsubscribeContactPreferenceError || saveContactPreferencesError ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
        bsStyle: "danger"
      }, (0, _angieslistAppPlatform.getErrorMessage)(unsubscribeContactPreferenceError || saveContactPreferencesError)) : null, hasUnsubscribed || hasSavedChanges ? hasUnsubscribed ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
        bsStyle: "info",
        id: "preferences--unsubscribe"
      }, displayUnsubscribeSuccessMessage(unsubscribedPrefType.displayName)) : /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
        bsStyle: "info",
        dismissAfter: 3000,
        onDismiss: function onDismiss() {
          _this.resetSavedForm(appName, resetSaveUserContactPreferencesByEmail, resetSaveAssociateContactPreferencesByEmail);
        }
      }, saveSuccessMessage) : null, /*#__PURE__*/_react["default"].createElement(_contactPreferenceCopy["default"], {
        email: email
      }), /*#__PURE__*/_react["default"].createElement(_ListGroup["default"], null, (0, _map2["default"])(contactPreferences, function (_ref2) {
        var key = _ref2.key,
          displayName = _ref2.displayName,
          description = _ref2.description,
          rank = _ref2.rank;
        return /*#__PURE__*/_react["default"].createElement(_ListGroupItem["default"], {
          key: rank
        }, /*#__PURE__*/_react["default"].createElement(_ReduxForm["default"].Input, {
          name: key,
          type: "checkbox",
          id: "contact-preferences-form--checkbox-id".concat(rank),
          label: /*#__PURE__*/_react["default"].createElement("b", null, displayName)
        }), description);
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-center"
      }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        id: "contact-preferences-form--save-button",
        flat: true,
        bsStyle: saveButtonStyle,
        disabled: pristine || invalid || isContactPreferenceLoading,
        loading: isSaveContactPreferencesLoading,
        bsSize: "small",
        type: "submit"
      }, "Save"))))));
    }
  }]);
}(_react["default"].Component);
ContactPreferences.propTypes = {
  email: _propTypes["default"].string.isRequired,
  serviceProviderId: _propTypes["default"].number,
  gateWay: _propTypes["default"].object,
  apiToken: _propTypes["default"].string.isRequired,
  appName: _propTypes["default"].string.isRequired,
  saveUserContactPreferencesByEmail: _propTypes["default"].func.isRequired,
  saveAssociateContactPreferencesByEmail: _propTypes["default"].func.isRequired,
  resetSaveUserContactPreferencesByEmail: _propTypes["default"].func.isRequired,
  resetSaveAssociateContactPreferencesByEmail: _propTypes["default"].func.isRequired,
  // redux form
  pristine: _propTypes["default"].bool.isRequired,
  invalid: _propTypes["default"].bool.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired
};
var ContactPreferencesReduxForm = (0, _reduxForm.reduxForm)({
  form: 'contact-preferences-unsubscribe',
  enableReinitialize: true
})(ContactPreferences);
var _default = exports["default"] = (0, _compose["default"])((0, _reactRedux.connect)(function (state, props) {
  var isMemberApp = props.appName === 'member-app';
  var gateWay = isMemberApp ? props.memberManagementGateway : props.serviceProviderGateway;
  var getContactPreferences = (0, _get5["default"])(gateWay, 'getContactPreferencesByEmail.response.preferences', {});
  var keyValuesArray = (0, _map2["default"])(getContactPreferences, function (pref) {
    return [pref.key, pref.enabled];
  });
  var fieldValues = (0, _fromPairs2["default"])(keyValuesArray);
  return {
    initialValues: fieldValues,
    gateWay: gateWay
  };
}, _objectSpread(_objectSpread(_objectSpread({}, memberMgmtGatewayActions), serviceProviderGatewayActions), myAccountUIActions)), _pure["default"])(ContactPreferencesReduxForm);

/***/ }),

/***/ 4305:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  pageBackground: {
    background: "url(".concat(__webpack_require__(4306), ") center top no-repeat"),
    backgroundSize: 'cover',
    zIndex: -1,
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  }
};
module.exports = exports.default;

/***/ }),

/***/ 4306:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0e713f861b22c675f69bdbe313d0a02e.jpg";

/***/ }),

/***/ 4389:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4390);

/***/ }),

/***/ 4390:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(2));
var _get2 = _interopRequireDefault(__webpack_require__(5));
var _pollerActions = __webpack_require__(1358);
var _angieslistAppPlatform = __webpack_require__(1);
var _uuid = _interopRequireDefault(__webpack_require__(4392));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports["default"] = {
  beforeConfigureStore: function beforeConfigureStore(options) {
    var ionOptions = {
      reducers: _objectSpread(_objectSpread({}, (options || {}).reducers), {}, {
        memberFaq: __webpack_require__(4395),
        memberFaqUI: __webpack_require__(4397),
        memberManagementGateway: __webpack_require__(4399),
        serviceProviderGateway: __webpack_require__(4400),
        myAccountUI: __webpack_require__(4401)
      })
    };
    return ionOptions;
  },
  afterConfigureStore: function afterConfigureStore(store) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    store.dispatch((0, _pollerActions.getConfig)());
    var appName = (0, _get2["default"])(store.getState(), 'config.appName');
    var appVersion = (0, _get2["default"])(store.getState(), 'config.appVersion');
    _angieslistAppPlatform.httpClient.addInterceptor({
      request: function request(_request) {
        _request.headers.set('X-ANGI-ProxyVersion', '1');
        _request.headers.set('X-ANGI-RequestId', _uuid["default"].v1());
        _request.headers.set('X-ANGI-SourceApplication', appName);
        _request.headers.set('X-ANGI-ApplicationVersion', appVersion);
        return _request;
      }
    });
  }
};
module.exports = exports.default;

/***/ }),

/***/ 4392:
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(4393);
var v4 = __webpack_require__(4394);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),

/***/ 4393:
/***/ (function(module, exports, __webpack_require__) {

// Unique ID creation requires a high quality random # generator.  We feature
// detect to determine the best RNG source, normalizing to a function that
// returns 128-bits of randomness, since that's what's usually required
var rng = __webpack_require__(2135);
var bytesToUuid = __webpack_require__(2136);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [
  _seedBytes[0] | 0x01,
  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0, _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),

/***/ 4394:
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(2135);
var bytesToUuid = __webpack_require__(2136);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),

/***/ 4395:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _redux = __webpack_require__(43);
var _memberFaqActionKeys = _interopRequireDefault(__webpack_require__(4396));
var _angieslistAppPlatform = __webpack_require__(1);
var faqTopics = [{
  topicId: '1',
  topicName: 'Account Settings'
}, {
  topicId: '2',
  topicName: 'General'
}, {
  topicId: '3',
  topicName: 'Reviews'
}, {
  topicId: '4',
  topicName: 'Memberships'
}, {
  topicId: '5',
  topicName: 'Tools & Features'
}, {
  topicId: '7',
  topicName: 'Member Benefits'
}, {
  topicId: '8',
  topicName: 'Common FAQ\'s'
}];
var faqTopicReducer = function faqTopicReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : faqTopics;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return state;
};
var _default = exports["default"] = (0, _redux.combineReducers)({
  memberFaqs: _angieslistAppPlatform.AsyncRequest.createReducer(_memberFaqActionKeys["default"].GET_MEMBER_FAQ),
  faqTopics: faqTopicReducer
});
module.exports = exports.default;

/***/ }),

/***/ 4396:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(2));
var _angieslistAppPlatform = __webpack_require__(1);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports["default"] = _objectSpread({}, _angieslistAppPlatform.AsyncRequest.createActionKeys('GET_MEMBER_FAQ'));
module.exports = exports.default;

/***/ }),

/***/ 4397:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(2));
var _angieslistAppPlatform = __webpack_require__(1);
var _memberFaqUIActionKeys = _interopRequireDefault(__webpack_require__(4398));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var initalState = {
  selectedTopicName: null,
  selectedTopicId: null
};
var memberFaqUIReducer = (0, _angieslistAppPlatform.createReducer)(initalState, (0, _defineProperty2["default"])({}, _memberFaqUIActionKeys["default"].NEW_FAQ_TOPIC_SELECTED, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    selectedTopicId: action.payload.faqTopicId,
    selectedTopicName: action.payload.faqTopicName
  });
}), false);
var _default = exports["default"] = memberFaqUIReducer;
module.exports = exports.default;

/***/ }),

/***/ 4398:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  NEW_FAQ_TOPIC_SELECTED: 'NEW_FAQ_TOPIC_SELECTED'
};
module.exports = exports.default;

/***/ }),

/***/ 4399:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
var _typeof = __webpack_require__(46);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(2));
var _find2 = _interopRequireDefault(__webpack_require__(79));
var _get2 = _interopRequireDefault(__webpack_require__(5));
var _redux = __webpack_require__(43);
var _angieslistAppPlatform = __webpack_require__(1);
var _cookieUtils = __webpack_require__(82);
var myAccountUIActions = _interopRequireWildcard(__webpack_require__(579));
var contactPreferencesActions = _interopRequireWildcard(__webpack_require__(2137));
var authActions = _interopRequireWildcard(__webpack_require__(422));
var _memberMgmtGatewayActionKeys = _interopRequireDefault(__webpack_require__(975));
var _immutable = __webpack_require__(241);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports["default"] = (0, _redux.combineReducers)({
  fetchUser: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].FETCH_USER, {
    'REMOVE_ADDRESS': function REMOVE_ADDRESS(state, action) {
      var updatedState = state.updateIn(['response', 'addresses'], function (addresses) {
        return addresses.filter(function (address) {
          return address.get('userAddressId') !== action.payload.userAddressId;
        });
      });
      return state.merge(updatedState);
    },
    'MAKE_PRIMARY_ADDRESS': function MAKE_PRIMARY_ADDRESS(state, action) {
      var updatedState = state.updateIn(['response', 'addresses'], function (userAddresses) {
        return userAddresses.map(function (address) {
          if (address.get('isPrimary')) {
            return address.set('isPrimary', false);
          } else if (address.get('userAddressId') === action.payload.userAddressId) {
            return address.set('isPrimary', true);
          } else {
            return address;
          }
        });
      });
      return state.merge(updatedState);
    },
    'UPDATE_PERSONAL_DETAILS': function UPDATE_PERSONAL_DETAILS(state, action) {
      var updatedPersonalDetails = state.updateIn(['response'], function (response) {
        var primaryContactInfo = response.get('primaryContactInformation');
        // eslint-disable-next-line
        var primaryContact = !primaryContactInfo ? (0, _immutable.Map)() : primaryContactInfo;
        var updatedPrimaryContact = primaryContact.merge({
          'primaryPhoneNumber': action.payload.contactInformation.primaryPhoneNumber,
          'mobilePhoneNumber': action.payload.contactInformation.mobilePhoneNumber
        });
        var setPersonalDetails = response.set('lastName', action.payload.lastName).set('firstName', action.payload.firstName).set('primaryContactInformation', updatedPrimaryContact);
        return setPersonalDetails;
      });
      return state.merge(updatedPersonalDetails);
    },
    'REFETCH_USER_SUCCESS': function REFETCH_USER_SUCCESS(state, action) {
      var newState = {
        response: action.payload.body
      };
      return state.merge(newState);
    }
  }),
  updateUser: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].UPDATE_USER),
  deleteUserAddress: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].DELETE_USER_ADDRESS, (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _memberMgmtGatewayActionKeys["default"].DELETE_USER_ADDRESS_START, function (state, action) {
    action.addSideEffect(function (store) {
      store.dispatch({
        type: _memberMgmtGatewayActionKeys["default"].SET_PRIMARY_ADDRESS_RESET
      });
    });
    return _angieslistAppPlatform.AsyncRequest.setStart(state, action.payload);
  }), _memberMgmtGatewayActionKeys["default"].DELETE_USER_ADDRESS_SUCCESS, function (state, action) {
    var currentState = state.toJS();
    var _currentState$request = currentState.request,
      userAddressId = _currentState$request.userAddressId,
      addressId = _currentState$request.addressId;
    action.addSideEffect(function (store) {
      store.dispatch(myAccountUIActions.deleteAddress(userAddressId, addressId));
    });
    return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload.body);
  })),
  setPrimaryAddress: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].SET_PRIMARY_ADDRESS, (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _memberMgmtGatewayActionKeys["default"].SET_PRIMARY_ADDRESS_START, function (state, action) {
    action.addSideEffect(function (store) {
      store.dispatch({
        type: _memberMgmtGatewayActionKeys["default"].DELETE_USER_ADDRESS_RESET
      });
    });
    return _angieslistAppPlatform.AsyncRequest.setStart(state, action.payload);
  }), _memberMgmtGatewayActionKeys["default"].SET_PRIMARY_ADDRESS_SUCCESS, function (state, action) {
    var currentState = state.toJS();
    var _currentState$request2 = currentState.request,
      userAddressId = _currentState$request2.userAddressId,
      addressId = _currentState$request2.addressId;
    action.addSideEffect(function (store) {
      var user = (0, _get2["default"])(store.getState(), 'user');
      var addresses = (0, _get2["default"])(user, 'userInfo.response._embedded.userAddresses');
      var address = (0, _find2["default"])(addresses, {
        'addressId': "".concat(addressId)
      });
      store.dispatch(myAccountUIActions.changeCurrentAddress(user, address));
      store.dispatch(myAccountUIActions.makePrimary(userAddressId, addressId));
    });
    return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload.body);
  })),
  changePassword: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].CHANGE_PASSWORD, (0, _defineProperty2["default"])({}, _memberMgmtGatewayActionKeys["default"].CHANGE_PASSWORD_SUCCESS, function (state, action) {
    action.addSideEffect(function (store) {
      (0, _cookieUtils.setCookie)('r', '/app/account');
      var storeState = store.getState();
      var identifier = (0, _get2["default"])(storeState, 'user.userInfo.response.email');
      var token = (0, _get2["default"])(storeState, 'memberManagementGateway.changePassword.request.newPassword');
      if (!!identifier && !!token) {
        store.dispatch(authActions.login(identifier, token));
      }
    });
    return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload);
  })),
  addAddress: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].ADD_ADDRESS),
  getContactPreferences: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].GET_USER_CONTACT_PREFERENCES, {
    'UPDATE_USER_CONTACT_PREF_STATE': function UPDATE_USER_CONTACT_PREF_STATE(state, action) {
      var updatedState = state.updateIn(['response', 'preferences'], function (preferences) {
        return preferences.map(function (pref) {
          var currentPref = (0, _find2["default"])(action.payload, {
            'key': pref.get('key')
          });
          return pref.set('enabled', currentPref.enabled);
        });
      });
      return state.merge(updatedState);
    }
  }),
  saveContactPreferences: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].SAVE_USER_CONTACT_PREFERENCES, (0, _defineProperty2["default"])({}, _memberMgmtGatewayActionKeys["default"].SAVE_USER_CONTACT_PREFERENCES_SUCCESS, function (state, action) {
    var currentState = state.toJS();
    var preferences = currentState.request.params.preferences;
    action.addSideEffect(function (store) {
      store.dispatch(myAccountUIActions.updateUserContactPrefState(preferences));
    });
    return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload);
  })),
  getMembershipInformation: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].GET_MEMBERSHIP_INFORMATION),
  getEligibleForRefund: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].GET_ELIGIBLE_FOR_REFUND),
  cancelAutoRenew: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].CANCEL_AUTO_RENEW),
  getContactPreferencesByEmail: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].GET_USER_CONTACT_PREFERENCES_BY_EMAIL, {
    'UPDATE_USER_CONTACT_PREF_STATE_BY_EMAIL': function UPDATE_USER_CONTACT_PREF_STATE_BY_EMAIL(state, action) {
      var updatedState = state.updateIn(['response', 'preferences'], function (preferences) {
        return preferences.map(function (pref) {
          var currentPref = (0, _find2["default"])(action.payload, {
            'key': pref.get('key')
          });
          if (currentPref) {
            return pref.set('enabled', currentPref.enabled);
          } else {
            return pref;
          }
        });
      });
      return state.merge(updatedState);
    }
  }),
  unsubscribeFromContactPreferenceByEmail: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].UNSUBSCRIBE_FROM_USER_CONTACT_PREFERENCE_BY_EMAIL, (0, _defineProperty2["default"])({}, _memberMgmtGatewayActionKeys["default"].UNSUBSCRIBE_FROM_USER_CONTACT_PREFERENCE_BY_EMAIL_SUCCESS, function (state, action) {
    var currentState = state.toJS();
    var preferences = currentState.request.params.preferences;
    action.addSideEffect(function (store) {
      store.dispatch(contactPreferencesActions.updateUserContactPrefStateByEmail(preferences));
    });
    return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload);
  })),
  saveContactPreferencesByEmail: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].SAVE_USER_CONTACT_PREFERENCES_BY_EMAIL, (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _memberMgmtGatewayActionKeys["default"].SAVE_USER_CONTACT_PREFERENCES_BY_EMAIL_START, function (state, action) {
    action.addSideEffect(function (store) {
      store.dispatch({
        type: _memberMgmtGatewayActionKeys["default"].UNSUBSCRIBE_FROM_USER_CONTACT_PREFERENCE_BY_EMAIL_RESET
      });
    });
    return _angieslistAppPlatform.AsyncRequest.setStart(state, action.payload);
  }), _memberMgmtGatewayActionKeys["default"].SAVE_USER_CONTACT_PREFERENCES_BY_EMAIL_SUCCESS, function (state, action) {
    var currentState = state.toJS();
    var preferences = currentState.request.params.preferences;
    action.addSideEffect(function (store) {
      store.dispatch(contactPreferencesActions.updateUserContactPrefStateByEmail(preferences));
    });
    return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload);
  })),
  submitPrivacyRequest: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].SUBMIT_PRIVACY_REQUEST, (0, _defineProperty2["default"])({}, _memberMgmtGatewayActionKeys["default"].SUBMIT_PRIVACY_REQUEST_SUCCESS, function (state) {
    return _objectSpread(_objectSpread({}, state.toJSON()), {}, {
      isLoading: false,
      response: {
        success: true
      }
    });
  })),
  verifyPrivacyRequest: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].VERIFY_PRIVACY_REQUEST)
});
module.exports = exports.default;

/***/ }),

/***/ 4400:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
var _typeof = __webpack_require__(46);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(2));
var _find2 = _interopRequireDefault(__webpack_require__(79));
var _redux = __webpack_require__(43);
var _angieslistAppPlatform = __webpack_require__(1);
var _cookieUtils = __webpack_require__(82);
var myAccountUIActions = _interopRequireWildcard(__webpack_require__(579));
var authActions = _interopRequireWildcard(__webpack_require__(422));
var _serviceProviderGatewayActionKeys = _interopRequireDefault(__webpack_require__(2100));
var contactPreferencesActions = _interopRequireWildcard(__webpack_require__(2137));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var _default = exports["default"] = (0, _redux.combineReducers)({
  getContactPreferences: _angieslistAppPlatform.AsyncRequest.createReducer(_serviceProviderGatewayActionKeys["default"].GET_ASSOCIATE_CONTACT_PREFERENCES, {
    'UPDATE_ASSOCIATE_CONTACT_PREF_STATE': function UPDATE_ASSOCIATE_CONTACT_PREF_STATE(state, action) {
      var updatedState = state.updateIn(['response', 'preferences'], function (preferences) {
        return preferences.map(function (pref) {
          var currentPref = (0, _find2["default"])(action.payload, {
            'key': pref.get('key')
          });
          return pref.set('enabled', currentPref.enabled);
        });
      });
      return state.merge(updatedState);
    }
  }),
  saveContactPreferences: _angieslistAppPlatform.AsyncRequest.createReducer(_serviceProviderGatewayActionKeys["default"].SAVE_ASSOCIATE_CONTACT_PREFERENCES, (0, _defineProperty2["default"])({}, _serviceProviderGatewayActionKeys["default"].SAVE_ASSOCIATE_CONTACT_PREFERENCES_SUCCESS, function (state, action) {
    var currentState = state.toJS();
    var preferences = currentState.request.params.preferences;
    action.addSideEffect(function (store) {
      store.dispatch(myAccountUIActions.updateAssociateContactPrefState(preferences));
    });
    return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload);
  })),
  getContactPreferencesByEmail: _angieslistAppPlatform.AsyncRequest.createReducer(_serviceProviderGatewayActionKeys["default"].GET_ASSOCIATE_CONTACT_PREFERENCES_BY_EMAIL, {
    'UPDATE_ASSOCIATE_CONTACT_PREF_STATE_BY_EMAIL': function UPDATE_ASSOCIATE_CONTACT_PREF_STATE_BY_EMAIL(state, action) {
      var updatedState = state.updateIn(['response', 'preferences'], function (preferences) {
        return preferences.map(function (pref) {
          var currentPref = (0, _find2["default"])(action.payload, {
            'key': pref.get('key')
          });
          if (currentPref) {
            return pref.set('enabled', currentPref.enabled);
          } else {
            return pref;
          }
        });
      });
      return state.merge(updatedState);
    }
  }),
  unsubscribeFromContactPreferenceByEmail: _angieslistAppPlatform.AsyncRequest.createReducer(_serviceProviderGatewayActionKeys["default"].UNSUBSCRIBE_FROM_ASSOCIATE_CONTACT_PREFERENCE_BY_EMAIL, (0, _defineProperty2["default"])({}, _serviceProviderGatewayActionKeys["default"].UNSUBSCRIBE_FROM_ASSOCIATE_CONTACT_PREFERENCE_BY_EMAIL_SUCCESS, function (state, action) {
    var currentState = state.toJS();
    var preferences = currentState.request.params.preferences;
    action.addSideEffect(function (store) {
      store.dispatch(contactPreferencesActions.updateAssociateContactPrefStateByEmail(preferences));
    });
    return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload);
  })),
  saveContactPreferencesByEmail: _angieslistAppPlatform.AsyncRequest.createReducer(_serviceProviderGatewayActionKeys["default"].SAVE_ASSOCIATE_CONTACT_PREFERENCES_BY_EMAIL, (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _serviceProviderGatewayActionKeys["default"].SAVE_ASSOCIATE_CONTACT_PREFERENCES_BY_EMAIL_START, function (state, action) {
    action.addSideEffect(function (store) {
      store.dispatch({
        type: _serviceProviderGatewayActionKeys["default"].UNSUBSCRIBE_FROM_ASSOCIATE_CONTACT_PREFERENCE_BY_EMAIL_RESET
      });
    });
    return _angieslistAppPlatform.AsyncRequest.setStart(state, action.payload);
  }), _serviceProviderGatewayActionKeys["default"].SAVE_ASSOCIATE_CONTACT_PREFERENCES_BY_EMAIL_SUCCESS, function (state, action) {
    var currentState = state.toJS();
    var preferences = currentState.request.params.preferences;
    action.addSideEffect(function (store) {
      store.dispatch(contactPreferencesActions.updateAssociateContactPrefStateByEmail(preferences));
    });
    return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload);
  }))
});
module.exports = exports.default;

/***/ }),

/***/ 4401:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
var _typeof = __webpack_require__(46);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(2));
var _add2 = _interopRequireDefault(__webpack_require__(4402));
var _reduce2 = _interopRequireDefault(__webpack_require__(1347));
var _get2 = _interopRequireDefault(__webpack_require__(5));
var _angieslistAppPlatform = __webpack_require__(1);
var _redux = __webpack_require__(43);
var _memberMgmtGatewayActionKeys = _interopRequireDefault(__webpack_require__(975));
var memberMgmtActions = _interopRequireWildcard(__webpack_require__(578));
var serviceProviderGatewayActions = _interopRequireWildcard(__webpack_require__(979));
var _immutable = __webpack_require__(241);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var sideEffectsReducer = (0, _angieslistAppPlatform.createReducer)({}, {
  'GET_USER_SUCCESS': function GET_USER_SUCCESS(state, action) {
    action.addSideEffect(function (store) {
      var storeState = store.getState();
      var userId = action.payload.body.userId;
      var pathName = (0, _get2["default"])(storeState, 'routing.locationBeforeTransitions.pathname');
      var appName = (0, _get2["default"])(storeState, 'config.appName');
      if (pathName === '/app/account' || pathName === '/app/account/' || pathName === '/app/account/preferences') {
        store.dispatch(memberMgmtActions.fetchUser(userId));
        if (appName === 'member-app') {
          store.dispatch(memberMgmtActions.getUserContactPreferences(userId));
          store.dispatch(memberMgmtActions.getMembershipInformation(userId));
          store.dispatch(memberMgmtActions.getEligibleForRefund());
        } else {
          store.dispatch(serviceProviderGatewayActions.getAssociateContactPreferences(userId));
        }
      }
    });
    return state;
  },
  'ADD_LOCATION_SUCCESS': function ADD_LOCATION_SUCCESS(state, action) {
    action.addSideEffect(function (store) {
      var pathName = (0, _get2["default"])(store.getState(), 'routing.locationBeforeTransitions.pathname').toLowerCase();
      var userId = (0, _get2["default"])(store.getState(), 'memberManagementGateway.fetchUser.response.userId');
      if (pathName === '/app/account' || pathName === '/app/account/' || pathName === '/app/account/preferences') {
        store.dispatch(memberMgmtActions.reFetchUser(userId));
      }
    });
    return state;
  }
});
var membershipInformationDetailsReducer = (0, _angieslistAppPlatform.createReducer)(new _immutable.Map({
  eligibleForRefund: false
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _memberMgmtGatewayActionKeys["default"].GET_MEMBERSHIP_INFORMATION_SUCCESS, function (state, action) {
  var payloadBody = (0, _get2["default"])(action, ['payload', 'body']);
  var updatedState = new _immutable.Map();
  var primaryMemberships = (0, _get2["default"])(payloadBody, 'primaryMemberships', []);
  var payloadTierName = (0, _get2["default"])(payloadBody, ['tier', 'tierName'], '');
  updatedState = updatedState.merge(new _immutable.Map({
    hasPrimarySubscriptionDetails: primaryMemberships.length > 0,
    tier: payloadTierName.toLowerCase(),
    isClassic: payloadTierName === 'classic',
    isGreen: payloadTierName === 'green',
    primaryMarket: (0, _get2["default"])(payloadBody, 'primaryMarket', '')
  }));
  if (updatedState.get('hasPrimarySubscriptionDetails')) {
    var primaryMembership = primaryMemberships[0];
    updatedState = updatedState.merge(new _immutable.Map({
      term: (0, _get2["default"])(primaryMembership, 'term'),
      renewalDate: (0, _get2["default"])(primaryMembership, 'renewalDate'),
      renewalPrice: (0, _get2["default"])(primaryMembership, ['renewalPrice', 'amount']),
      renewalType: (0, _get2["default"])(primaryMembership, 'renewalType', '').toLowerCase(),
      autoRenewalDescription: (0, _get2["default"])(primaryMembership, 'renewalType').toLowerCase() === 'auto' ? 'Auto Renew' : 'Manual Renew',
      isPayingMember: !!(0, _reduce2["default"])(primaryMemberships.map(function (m) {
        return (0, _get2["default"])(m, ['renewalPrice', 'amount'], 0);
      }), _add2["default"]) && !updatedState.get('isGreen', false)
    }));
    updatedState = updatedState.set('isExpired', new Date() > new Date((0, _get2["default"])(primaryMembership, 'renewalDate')));
  }
  return state.mergeDeep(updatedState);
}), _memberMgmtGatewayActionKeys["default"].GET_ELIGIBLE_FOR_REFUND_SUCCESS, function (state, action) {
  var payloadBody = (0, _get2["default"])(action, ['payload', 'body']);
  return state.mergeDeep(new _immutable.Map({
    eligibleForRefund: (0, _get2["default"])(payloadBody, 'eligibleForRefund', false)
  }));
}));
var _default = exports["default"] = (0, _redux.combineReducers)({
  sideEffects: sideEffectsReducer,
  membershipInformationDetails: membershipInformationDetailsReducer
});
module.exports = exports.default;

/***/ }),

/***/ 4402:
/***/ (function(module, exports, __webpack_require__) {

var createMathOperation = __webpack_require__(4403);

/**
 * Adds two numbers.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {number} augend The first number in an addition.
 * @param {number} addend The second number in an addition.
 * @returns {number} Returns the total.
 * @example
 *
 * _.add(6, 4);
 * // => 10
 */
var add = createMathOperation(function(augend, addend) {
  return augend + addend;
}, 0);

module.exports = add;


/***/ }),

/***/ 4403:
/***/ (function(module, exports, __webpack_require__) {

var baseToNumber = __webpack_require__(4404),
    baseToString = __webpack_require__(874);

/**
 * Creates a function that performs a mathematical operation on two values.
 *
 * @private
 * @param {Function} operator The function to perform the operation.
 * @param {number} [defaultValue] The value used for `undefined` arguments.
 * @returns {Function} Returns the new mathematical operation function.
 */
function createMathOperation(operator, defaultValue) {
  return function(value, other) {
    var result;
    if (value === undefined && other === undefined) {
      return defaultValue;
    }
    if (value !== undefined) {
      result = value;
    }
    if (other !== undefined) {
      if (result === undefined) {
        return other;
      }
      if (typeof value == 'string' || typeof other == 'string') {
        value = baseToString(value);
        other = baseToString(other);
      } else {
        value = baseToNumber(value);
        other = baseToNumber(other);
      }
      result = operator(value, other);
    }
    return result;
  };
}

module.exports = createMathOperation;


/***/ }),

/***/ 4404:
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(406);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/**
 * The base implementation of `_.toNumber` which doesn't ensure correct
 * conversions of binary, hexadecimal, or octal string values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 */
function baseToNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  return +value;
}

module.exports = baseToNumber;


/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAddress = addAddress;
exports.cancelAutoRenew = cancelAutoRenew;
exports.changeUserPassword = changeUserPassword;
exports.deleteUserAddress = deleteUserAddress;
exports.fetchUser = fetchUser;
exports.getEligibleForRefund = getEligibleForRefund;
exports.getMembershipInformation = getMembershipInformation;
exports.getUserContactPreferences = getUserContactPreferences;
exports.getUserContactPreferencesByEmail = getUserContactPreferencesByEmail;
exports.reFetchUser = reFetchUser;
exports.resetChangeUserPassword = resetChangeUserPassword;
exports.resetSaveUserContactPreferencesByEmail = resetSaveUserContactPreferencesByEmail;
exports.saveUserContactPreferences = saveUserContactPreferences;
exports.saveUserContactPreferencesByEmail = saveUserContactPreferencesByEmail;
exports.setPrimaryAddress = setPrimaryAddress;
exports.submitPrivacyRequest = submitPrivacyRequest;
exports.unsubscribeFromUserContactPreferenceByEmail = unsubscribeFromUserContactPreferenceByEmail;
exports.updateUser = updateUser;
exports.verifyPrivacyRequest = verifyPrivacyRequest;
var _memberMgmtGatewayActionKeys = _interopRequireDefault(__webpack_require__(975));
var _memberMgmtGatewayService = _interopRequireDefault(__webpack_require__(4252));
function fetchUser(userId) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].FETCH_USER,
    payload: {
      promise: _memberMgmtGatewayService["default"].fetchUser(userId)
    }
  };
}
function reFetchUser(userId) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].REFETCH_USER,
    payload: {
      promise: _memberMgmtGatewayService["default"].fetchUser(userId)
    }
  };
}
function updateUser(params) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].UPDATE_USER,
    payload: {
      data: {
        params: params
      },
      promise: _memberMgmtGatewayService["default"].updateUser(params)
    }
  };
}
function addAddress(params) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].ADD_ADDRESS,
    payload: {
      data: {
        params: params
      },
      promise: _memberMgmtGatewayService["default"].updateUser(params)
    }
  };
}
function deleteUserAddress(userAddressId, addressId) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].DELETE_USER_ADDRESS,
    payload: {
      data: {
        userAddressId: userAddressId,
        addressId: addressId
      },
      promise: _memberMgmtGatewayService["default"].deleteUserAddress(userAddressId)
    }
  };
}
function setPrimaryAddress(userAddressId, addressId) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].SET_PRIMARY_ADDRESS,
    payload: {
      data: {
        userAddressId: userAddressId,
        addressId: addressId
      },
      promise: _memberMgmtGatewayService["default"].setPrimaryAddress(userAddressId)
    }
  };
}
function changeUserPassword(oldPassword, newPassword) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].CHANGE_PASSWORD,
    payload: {
      data: {
        oldPassword: oldPassword,
        newPassword: newPassword
      },
      promise: _memberMgmtGatewayService["default"].changePassword(oldPassword, newPassword)
    }
  };
}
function resetChangeUserPassword() {
  return {
    type: _memberMgmtGatewayActionKeys["default"].CHANGE_PASSWORD_RESET,
    payload: {}
  };
}
function getUserContactPreferences(userId) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].GET_USER_CONTACT_PREFERENCES,
    payload: {
      promise: _memberMgmtGatewayService["default"].getUserContactPreferences(userId)
    }
  };
}
function saveUserContactPreferences(params) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].SAVE_USER_CONTACT_PREFERENCES,
    payload: {
      data: {
        params: params
      },
      promise: _memberMgmtGatewayService["default"].saveUserContactPreferences(params)
    }
  };
}
function getMembershipInformation(userId) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].GET_MEMBERSHIP_INFORMATION,
    payload: {
      data: {
        userId: userId
      },
      promise: _memberMgmtGatewayService["default"].getMembershipInformation(userId)
    }
  };
}
function getEligibleForRefund() {
  return {
    type: _memberMgmtGatewayActionKeys["default"].GET_ELIGIBLE_FOR_REFUND,
    payload: {
      promise: _memberMgmtGatewayService["default"].getEligibleForRefund()
    }
  };
}
function cancelAutoRenew() {
  return {
    type: _memberMgmtGatewayActionKeys["default"].CANCEL_AUTO_RENEW,
    payload: {
      promise: _memberMgmtGatewayService["default"].cancelAutoRenew()
    }
  };
}
function getUserContactPreferencesByEmail(email, apiToken) {
  return {
    type: _memberMgmtGatewayActionKeys["default"].GET_USER_CONTACT_PREFERENCES_BY_EMAIL,
    payload: {
      promise: _memberMgmtGatewayService["default"].getUserContactPreferencesByEmail(email, apiToken)
    }
  };
}

// Unsubscribe action uses the same API as saving user contact preferences.
// It is a separate action to allow UI to render different alert messages on unsubscribing on page load vs. saving from a form submit.
function unsubscribeFromUserContactPreferenceByEmail(_ref) {
  var email = _ref.email,
    apiToken = _ref.apiToken,
    preferences = _ref.preferences;
  return {
    type: _memberMgmtGatewayActionKeys["default"].UNSUBSCRIBE_FROM_USER_CONTACT_PREFERENCE_BY_EMAIL,
    payload: {
      data: {
        params: {
          email: email,
          apiToken: apiToken,
          preferences: preferences
        }
      },
      promise: _memberMgmtGatewayService["default"].saveUserContactPreferencesByEmail({
        email: email,
        apiToken: apiToken,
        preferences: preferences
      })
    }
  };
}
function saveUserContactPreferencesByEmail(_ref2) {
  var email = _ref2.email,
    apiToken = _ref2.apiToken,
    preferences = _ref2.preferences;
  return {
    type: _memberMgmtGatewayActionKeys["default"].SAVE_USER_CONTACT_PREFERENCES_BY_EMAIL,
    payload: {
      data: {
        params: {
          email: email,
          apiToken: apiToken,
          preferences: preferences
        }
      },
      promise: _memberMgmtGatewayService["default"].saveUserContactPreferencesByEmail({
        email: email,
        apiToken: apiToken,
        preferences: preferences
      })
    }
  };
}
function resetSaveUserContactPreferencesByEmail() {
  return {
    type: _memberMgmtGatewayActionKeys["default"].SAVE_USER_CONTACT_PREFERENCES_BY_EMAIL_RESET
  };
}
function submitPrivacyRequest(_ref3) {
  var email = _ref3.email,
    privacyRequestType = _ref3.privacyRequestType;
  return {
    type: _memberMgmtGatewayActionKeys["default"].SUBMIT_PRIVACY_REQUEST,
    payload: {
      data: {
        params: {
          email: email,
          privacyRequestType: privacyRequestType
        }
      },
      promise: _memberMgmtGatewayService["default"].submitPrivacyRequest({
        email: email,
        privacyRequestType: privacyRequestType
      })
    }
  };
}
function verifyPrivacyRequest(_ref4) {
  var email = _ref4.email,
    verificationToken = _ref4.verificationToken,
    requestStatus = _ref4.requestStatus;
  return {
    type: _memberMgmtGatewayActionKeys["default"].VERIFY_PRIVACY_REQUEST,
    payload: {
      promise: _memberMgmtGatewayService["default"].verifyPrivacyRequest({
        email: email,
        verificationToken: verificationToken,
        requestStatus: requestStatus
      })
    }
  };
}

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeCurrentAddress = changeCurrentAddress;
exports.deleteAddress = deleteAddress;
exports.makePrimary = makePrimary;
exports.resetStore = resetStore;
exports.updateAssociateContactPrefState = updateAssociateContactPrefState;
exports.updatePersonalDetails = updatePersonalDetails;
exports.updateUserContactPrefState = updateUserContactPrefState;
var _get2 = _interopRequireDefault(__webpack_require__(5));
var _cookieUtils = _interopRequireDefault(__webpack_require__(82));
var setCookie = function setCookie(address) {
  var userAddresses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (true) {
    var cookie = {
      currentAddressId: (address || {}).addressId,
      order: userAddresses.map(function (addr) {
        return addr.addressId;
      })
    };
    _cookieUtils["default"].setCookie('user', JSON.stringify(cookie));
  }
};
function deleteAddress(userAddressId, addressId) {
  return {
    type: 'REMOVE_ADDRESS',
    payload: {
      userAddressId: userAddressId,
      addressId: addressId
    }
  };
}
function makePrimary(userAddressId, addressId) {
  return {
    type: 'MAKE_PRIMARY_ADDRESS',
    payload: {
      userAddressId: userAddressId,
      addressId: addressId
    }
  };
}
function changeCurrentAddress(user) {
  var address = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if ((0, _get2["default"])(user, 'userInfo.response')) {
    setCookie(address, (0, _get2["default"])(user, 'userInfo.response._embedded.userAddresses'));
  }
  return {
    type: 'CHANGE_CURRENT_ADDRESS',
    payload: address
  };
}
function updatePersonalDetails() {
  var personalDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: 'UPDATE_PERSONAL_DETAILS',
    payload: personalDetails
  };
}
function resetStore(type) {
  return {
    type: type
  };
}
function updateUserContactPrefState() {
  var cPreferences = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: 'UPDATE_USER_CONTACT_PREF_STATE',
    payload: cPreferences
  };
}
function updateAssociateContactPrefState() {
  var cPreferences = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: 'UPDATE_ASSOCIATE_CONTACT_PREF_STATE',
    payload: cPreferences
  };
}

/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(2));
var _angieslistAppPlatform = __webpack_require__(1);
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports["default"] = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _angieslistAppPlatform.AsyncRequest.createActionKeys('FETCH_USER')), _angieslistAppPlatform.AsyncRequest.createActionKeys('UPDATE_USER')), _angieslistAppPlatform.AsyncRequest.createActionKeys('DELETE_USER_ADDRESS')), _angieslistAppPlatform.AsyncRequest.createActionKeys('SET_PRIMARY_ADDRESS')), _angieslistAppPlatform.AsyncRequest.createActionKeys('CHANGE_PASSWORD')), _angieslistAppPlatform.AsyncRequest.createActionKeys('ADD_ADDRESS')), _angieslistAppPlatform.AsyncRequest.createActionKeys('REFETCH_USER')), _angieslistAppPlatform.AsyncRequest.createActionKeys('GET_USER_CONTACT_PREFERENCES')), _angieslistAppPlatform.AsyncRequest.createActionKeys('SAVE_USER_CONTACT_PREFERENCES')), _angieslistAppPlatform.AsyncRequest.createActionKeys('UPDATE_USER_CONTACT_PREF_STATE')), _angieslistAppPlatform.AsyncRequest.createActionKeys('GET_MEMBERSHIP_INFORMATION')), _angieslistAppPlatform.AsyncRequest.createActionKeys('GET_ELIGIBLE_FOR_REFUND')), _angieslistAppPlatform.AsyncRequest.createActionKeys('CANCEL_AUTO_RENEW')), _angieslistAppPlatform.AsyncRequest.createActionKeys('GET_USER_CONTACT_PREFERENCES_BY_EMAIL')), _angieslistAppPlatform.AsyncRequest.createActionKeys('UNSUBSCRIBE_FROM_USER_CONTACT_PREFERENCE_BY_EMAIL')), _angieslistAppPlatform.AsyncRequest.createActionKeys('SAVE_USER_CONTACT_PREFERENCES_BY_EMAIL')), _angieslistAppPlatform.AsyncRequest.createActionKeys('UPDATE_USER_CONTACT_PREF_STATE_BY_EMAIL')), _angieslistAppPlatform.AsyncRequest.createActionKeys('SUBMIT_PRIVACY_REQUEST')), _angieslistAppPlatform.AsyncRequest.createActionKeys('VERIFY_PRIVACY_REQUEST'));
module.exports = exports.default;

/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAssociateContactPreferences = getAssociateContactPreferences;
exports.getAssociateContactPreferencesByEmail = getAssociateContactPreferencesByEmail;
exports.resetSaveAssociateContactPreferencesByEmail = resetSaveAssociateContactPreferencesByEmail;
exports.saveAssociateContactPreferences = saveAssociateContactPreferences;
exports.saveAssociateContactPreferencesByEmail = saveAssociateContactPreferencesByEmail;
exports.unsubscribeFromAssociateContactPreferenceByEmail = unsubscribeFromAssociateContactPreferenceByEmail;
var _serviceProviderGatewayActionKeys = _interopRequireDefault(__webpack_require__(2100));
var _serviceProviderGatewayService = _interopRequireDefault(__webpack_require__(4294));
function getAssociateContactPreferences(userId) {
  return {
    type: _serviceProviderGatewayActionKeys["default"].GET_ASSOCIATE_CONTACT_PREFERENCES,
    payload: {
      promise: _serviceProviderGatewayService["default"].getAssociateContactPreferences(userId)
    }
  };
}
function saveAssociateContactPreferences(params) {
  return {
    type: _serviceProviderGatewayActionKeys["default"].SAVE_ASSOCIATE_CONTACT_PREFERENCES,
    payload: {
      data: {
        params: params
      },
      promise: _serviceProviderGatewayService["default"].saveAssociateContactPreferences(params)
    }
  };
}
function getAssociateContactPreferencesByEmail(email, apiToken, serviceProviderId) {
  return {
    type: _serviceProviderGatewayActionKeys["default"].GET_ASSOCIATE_CONTACT_PREFERENCES_BY_EMAIL,
    payload: {
      promise: _serviceProviderGatewayService["default"].getAssociateContactPreferencesByEmail(email, apiToken, serviceProviderId)
    }
  };
}
function saveAssociateContactPreferencesByEmail(_ref) {
  var email = _ref.email,
    apiToken = _ref.apiToken,
    preferences = _ref.preferences,
    serviceProviderId = _ref.serviceProviderId;
  return {
    type: _serviceProviderGatewayActionKeys["default"].SAVE_ASSOCIATE_CONTACT_PREFERENCES_BY_EMAIL,
    payload: {
      data: {
        params: {
          email: email,
          apiToken: apiToken,
          preferences: preferences,
          serviceProviderId: serviceProviderId
        }
      },
      promise: _serviceProviderGatewayService["default"].saveAssociateContactPreferencesByEmail({
        email: email,
        apiToken: apiToken,
        preferences: preferences,
        serviceProviderId: serviceProviderId
      })
    }
  };
}

// Unsubscribe action uses the same API as saving associate contact preferences.
// It is a separate action to allow UI to render different alert messages on unsubscribing on page load vs. saving from a form submit.
function unsubscribeFromAssociateContactPreferenceByEmail(_ref2) {
  var email = _ref2.email,
    apiToken = _ref2.apiToken,
    preferences = _ref2.preferences,
    serviceProviderId = _ref2.serviceProviderId;
  return {
    type: _serviceProviderGatewayActionKeys["default"].UNSUBSCRIBE_FROM_ASSOCIATE_CONTACT_PREFERENCE_BY_EMAIL,
    payload: {
      data: {
        params: {
          email: email,
          apiToken: apiToken,
          preferences: preferences,
          serviceProviderId: serviceProviderId
        }
      },
      promise: _serviceProviderGatewayService["default"].saveAssociateContactPreferencesByEmail({
        email: email,
        apiToken: apiToken,
        preferences: preferences,
        serviceProviderId: serviceProviderId
      })
    }
  };
}
function resetSaveAssociateContactPreferencesByEmail() {
  return {
    type: _serviceProviderGatewayActionKeys["default"].SAVE_ASSOCIATE_CONTACT_PREFERENCES_BY_EMAIL_RESET
  };
}

/***/ })

},[2818]);


// WEBPACK FOOTER //
// account-ion-d01430da3fa5fe7aac8b.js